<template>
    <v-container max-width="100%" style="margin-top: 3%; padding: 0;">
        <v-container style="margin-left: 0px; margin-right: 0px; padding-left: 0px; padding-right: 0px;">
            <v-row>
                <v-col cols="12" sm="3">
                    <v-card class="mx-auto" tile width="100%">
                        <v-navigation-drawer permanent width="100%">
                            <v-list>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <span class="headline" style="color: #4a4a4a">{{
                                                $t('config.navigation.title')
                                            }}</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-divider></v-divider>
                            <v-list nav dense>
                                <v-list-item-group v-model="selectedSection" color="primary">
                                    <template v-for="(section, i) in sections">
                                        <!-- :value fixo: seção escondida não pode deslocar o índice das outras -->
                                        <v-list-item v-if="section.show !== false" :key="i" :value="i">
                                            <v-list-item-icon>
                                                <v-icon v-text="section.icon"></v-icon>
                                            </v-list-item-icon>

                                            <v-list-item-content>
                                                <v-list-item-title v-text="section.text"></v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-list-item-group>
                            </v-list>
                        </v-navigation-drawer>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="9">
                    <v-card>
                        <v-card-title>
                            <span class="headline" style="color: #4a4a4a">{{ title }}</span>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-card-text>
                            <v-list height="70vh" style="overflow-y: auto; overflow-x: hidden;">
                                <template v-if="selectedSection === 0">
                                    <v-list-item-group multiple>
                                        <v-row>
                                            <v-col cols="12" sm="4" v-show="config.usar_guias">
                                                <ConfigItem :title="configTexts.usarGuias.title"
                                                    :subtitle="configTexts.usarGuias.subtitle"
                                                    :helpText="configTexts.usarGuias.helpText" vertical>
                                                    <v-checkbox v-model="config.usar_guias" hide-details></v-checkbox>
                                                </ConfigItem>
                                            </v-col>
                                            <v-col cols="12" sm="4" v-show="config.usar_guias">
                                                <ConfigItem :title="configTexts.guiasAutomaticas.title"
                                                    :subtitle="configTexts.guiasAutomaticas.subtitle"
                                                    :helpText="configTexts.guiasAutomaticas.helpText" vertical>
                                                    <v-checkbox v-model="config.guias_automaticas"
                                                        :disabled="!config.usar_guias" hide-details></v-checkbox>
                                                </ConfigItem>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <ConfigItem :title="configTexts.cadastroPassageiros.title"
                                                    :subtitle="configTexts.cadastroPassageiros.subtitle"
                                                    :helpText="configTexts.cadastroPassageiros.helpText" vertical>
                                                    <v-checkbox v-model="config.permitir_cadastro_passageiros"
                                                        hide-details></v-checkbox>
                                                </ConfigItem>
                                            </v-col>
                                        </v-row>
                                    </v-list-item-group>

                                    <v-divider></v-divider>

                                    <v-list-item-group multiple>
                                        <v-row>
                                            <v-col cols="12" sm="4">
                                                <ConfigItem :title="configTexts.inicializaGridDiario.title"
                                                    :subtitle="configTexts.inicializaGridDiario.subtitle"
                                                    :helpText="configTexts.inicializaGridDiario.helpText" vertical>
                                                    <v-checkbox v-model="config.inicializa_grid_diario" hide-details></v-checkbox>
                                                </ConfigItem>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <ConfigItem :title="configTexts.usaEscalasPadrao.title"
                                                    :subtitle="configTexts.usaEscalasPadrao.subtitle"
                                                    :helpText="configTexts.usaEscalasPadrao.helpText" vertical>
                                                    <v-checkbox v-model="config.usa_escalas_padrao" hide-details></v-checkbox>
                                                </ConfigItem>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <ConfigItem :title="configTexts.motoristaCreateTrip.title"
                                                    :subtitle="configTexts.motoristaCreateTrip.subtitle"
                                                    :helpText="configTexts.motoristaCreateTrip.helpText" vertical>
                                                    <v-checkbox v-model="config.motorista_cria_viagem" hide-details></v-checkbox>
                                                </ConfigItem>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <ConfigItem :title="configTexts.motoristaInicioJornadaObrigatorio.title"
                                                    :subtitle="configTexts.motoristaInicioJornadaObrigatorio.subtitle"
                                                    :helpText="configTexts.motoristaInicioJornadaObrigatorio.helpText" vertical>
                                                    <v-checkbox v-model="config.motorista_inicio_jornada_obrigatorio" hide-details></v-checkbox>
                                                </ConfigItem>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <ConfigItem :title="configTexts.motoristaCheckoutMinutosAposCheckin.title"
                                                    :subtitle="configTexts.motoristaCheckoutMinutosAposCheckin.subtitle"
                                                    :helpText="configTexts.motoristaCheckoutMinutosAposCheckin.helpText" vertical>
                                                    <v-text-field
                                                        v-model.number="config.motorista_checkout_minutos_apos_checkin"
                                                        type="number"
                                                        min="0"
                                                        suffix="min"
                                                        dense
                                                        :rules="[
                                                            (v) => (v !== '' && v != null && Number(v) >= 0) ||
                                                                $t('config.system_parameters.motoristaCheckoutMinutosAposCheckin.helpText')
                                                        ]"
                                                    />
                                                </ConfigItem>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <ConfigItem :title="configTexts.motoristaPermiteAbrirGuiaForaCerca.title"
                                                    :subtitle="configTexts.motoristaPermiteAbrirGuiaForaCerca.subtitle"
                                                    :helpText="configTexts.motoristaPermiteAbrirGuiaForaCerca.helpText" vertical>
                                                    <v-checkbox v-model="config.motorista_permite_abrir_guia_fora_cerca" hide-details></v-checkbox>
                                                </ConfigItem>
                                            </v-col>
                                            <v-col cols="12" sm="8">
                                                <ConfigItem :title="configTexts.motoristaTiposCercaAbrirGuia.title"
                                                    :subtitle="configTexts.motoristaTiposCercaAbrirGuia.subtitle"
                                                    :helpText="configTexts.motoristaTiposCercaAbrirGuia.helpText" vertical>
                                                    <MultiplaEscolha
                                                        ref="motoristaTiposCercaSelect"
                                                        :items="tiposCerca"
                                                        :selected-items.sync="motoristaTiposCercaSelecionados"
                                                        text="descricaoLabel"
                                                        value="id_tipo_cerca"
                                                        :can-toggle-all="true"
                                                        :disabled="!!config.motorista_permite_abrir_guia_fora_cerca"
                                                    />
                                                </ConfigItem>
                                            </v-col>
                                        </v-row>
                                    </v-list-item-group>

                                    <v-divider></v-divider>

                                    <v-list-item-group style="margin-top: 5px;">
                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="12" sm="12">
                                                        <ConfigItem :title="configTexts.periodoBuscaAlertas.title"
                                                            :subtitle="configTexts.periodoBuscaAlertas.subtitle"
                                                            :helpText="configTexts.periodoBuscaAlertas.helpText"
                                                            vertical>
                                                            <v-row>
                                                                <v-col cols="12" sm="6">
                                                                    <v-text-field v-model="config.periodo_busca_alertas_minutos"
                                                                        type="number" min="1" suffix="min" :rules="[
                                                                            v => v >= 1 || $t('config.navigation.sections.minMinutes'),
                                                                            v => v <= 10080 || $t('config.navigation.sections.maxMinutes')
                                                                        ]" placeholder="Ex: 60, 1440" dense
                                                                        :label="$t('config.navigation.sections.periodMinutes')">
                                                                    </v-text-field>
                                                                </v-col>
                                                                <v-col cols="12" sm="6">
                                                                    <v-text-field v-model.number="periodoHoras" type="number"
                                                                        :label="$t('config.navigation.sections.periodHours')"
                                                                        :hint="$t('config.navigation.sections.digitHours')"
                                                                        @input="config.periodo_busca_alertas_minutos = periodoHoras * 60"
                                                                        dense>
                                                                    </v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem :title="configTexts.limiteAlertasTela.title"
                                                            :subtitle="configTexts.limiteAlertasTela.subtitle"
                                                            :helpText="configTexts.limiteAlertasTela.helpText" vertical>
                                                            <v-text-field
                                                                v-model="config.limite_alertas_tela"
                                                                type="number"
                                                                min="0"
                                                                max="99"
                                                                dense
                                                                hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem :title="configTexts.limiteLinhasExportacaoCsvLocal.title"
                                                            :subtitle="configTexts.limiteLinhasExportacaoCsvLocal.subtitle"
                                                            :helpText="configTexts.limiteLinhasExportacaoCsvLocal.helpText" vertical>
                                                            <v-text-field
                                                                v-model.number="config.limite_linhas_exportacao_csv_local"
                                                                type="number"
                                                                min="1"
                                                                step="1"
                                                                dense
                                                                :rules="[
                                                                    (v) => Number.isInteger(Number(v)) && Number(v) > 0 ||
                                                                        $t('config.system_parameters.csv_local_row_limit.helpText')
                                                                ]"
                                                            />
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>

                                    <v-divider></v-divider>

                                    <v-list-item-group multiple>
                                        <v-row>
                                            <v-col cols="12" sm="4" v-show="config.lat_default">
                                                <ConfigItem :title="configTexts.latDefault.title"
                                                    :subtitle="configTexts.latDefault.subtitle"
                                                    :helpText="configTexts.latDefault.helpText" vertical>
                                                    <v-text-field v-model="config.lat_default" type="number" dense
                                                        hide-details></v-text-field>
                                                </ConfigItem>
                                            </v-col>
                                            <v-col cols="12" sm="4" v-show="config.lng_default">
                                                <ConfigItem :title="configTexts.lngDefault.title"
                                                    :subtitle="configTexts.lngDefault.subtitle"
                                                    :helpText="configTexts.lngDefault.helpText" vertical>
                                                    <v-text-field v-model="config.lng_default" type="number" dense
                                                        hide-details></v-text-field>
                                                </ConfigItem>
                                            </v-col>
                                        </v-row>
                                    </v-list-item-group>

                                    <v-divider></v-divider>

                                    <v-list-item-group style="margin-top: 5px;">
                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem :title="configTexts.atrasoMinimo.title"
                                                            :subtitle="configTexts.atrasoMinimo.subtitle"
                                                            :helpText="configTexts.atrasoMinimo.helpText" vertical>
                                                            <v-text-field
                                                                v-model="config.atraso_minimo_viagens_previstas"
                                                                type="number" dense hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem :title="configTexts.atrasoMaximo.title"
                                                            :subtitle="configTexts.atrasoMaximo.subtitle"
                                                            :helpText="configTexts.atrasoMaximo.helpText" vertical>
                                                            <v-text-field
                                                                v-model="config.atraso_maximo_viagens_previstas"
                                                                type="number" dense hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem :title="configTexts.limiteAdiantamento.title"
                                                            :subtitle="configTexts.limiteAdiantamento.subtitle"
                                                            :helpText="configTexts.limiteAdiantamento.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.limite_adiantamento_viagem_prevista"
                                                                type="number" dense hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem :title="configTexts.tempoLimiteLargada.title"
                                                            :subtitle="configTexts.tempoLimiteLargada.subtitle"
                                                            :helpText="configTexts.tempoLimiteLargada.helpText"
                                                            vertical>
                                                            <v-text-field v-model="config.limite_tempo_largada"
                                                                type="number" dense hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem
                                                            :title="configTexts.tempoLimiteFechamentoAutomatico.title"
                                                            :subtitle="configTexts.tempoLimiteFechamentoAutomatico.subtitle"
                                                            :helpText="configTexts.tempoLimiteFechamentoAutomatico.helpText"
                                                            vertical>
                                                            <v-text-field v-model="config.tempo_fechamento_automatico"
                                                                type="number" dense hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem :title="configTexts.limiteDeTempoParado.title"
                                                            :subtitle="configTexts.limiteDeTempoParado.subtitle"
                                                            :helpText="configTexts.limiteDeTempoParado.helpText"
                                                            vertical>
                                                            <v-text-field v-model="config.limite_tempo_parado"
                                                                type="number" dense hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>

                                    <v-divider></v-divider>

                                    <v-list-item-group style="margin-top: 5px;">
                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem :title="configTexts.distanciaLimiteComboio.title"
                                                            :subtitle="configTexts.distanciaLimiteComboio.subtitle"
                                                            :helpText="configTexts.distanciaLimiteComboio.helpText"
                                                            vertical>
                                                            <v-text-field v-model="config.distancia_limite_comboio"
                                                                type="number" dense hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem :title="configTexts.tempoCicloComboio.title"
                                                            :subtitle="configTexts.tempoCicloComboio.subtitle"
                                                            :helpText="configTexts.tempoCicloComboio.helpText" vertical>
                                                            <v-text-field v-model="config.tempo_ciclo_comboio"
                                                                type="number" dense hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem :title="configTexts.intervaloPosicoesComboio.title"
                                                            :subtitle="configTexts.intervaloPosicoesComboio.subtitle"
                                                            :helpText="configTexts.intervaloPosicoesComboio.helpText"
                                                            vertical>
                                                            <v-text-field v-model="config.intervalo_posicoes_comboio"
                                                                type="number" dense hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>

                                    <v-divider></v-divider>

                                    <v-list-item-group style="margin-top: 5px;">
                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem :title="configTexts.diaOperacional.title"
                                                            :subtitle="configTexts.diaOperacional.subtitle"
                                                            :helpText="configTexts.diaOperacional.helpText" vertical>
                                                            <v-text-field v-model="config.hora_inicial_dia_operacao"
                                                                prepend-icon="mdi-clock" v-mask="'##:##'"
                                                                :rules="[(v) => horarioRules(v)]"></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem :title="configTexts.diaFinanceiro.title"
                                                            :subtitle="configTexts.diaFinanceiro.subtitle"
                                                            :helpText="configTexts.diaFinanceiro.helpText" vertical>
                                                            <v-text-field v-model="config.hora_inicial_dia_financeiro"
                                                                prepend-icon="mdi-clock" v-mask="'##:##'"
                                                                :rules="[(v) => horarioRules(v)]"></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>

                                    <v-divider></v-divider>

                                    <v-list-item-group style="margin-top: 5px;">
                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem :title="configTexts.raioCercaPadrao.title"
                                                            :subtitle="configTexts.raioCercaPadrao.subtitle"
                                                            :helpText="configTexts.raioCercaPadrao.helpText" vertical>
                                                            <v-text-field v-model="config.raio_cerca_padrao"
                                                                type="number" min="1" dense hide-details>
                                                            </v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem :title="configTexts.limiteAtrasoCercaPadrao.title"
                                                            :subtitle="configTexts.limiteAtrasoCercaPadrao.subtitle"
                                                            :helpText="configTexts.limiteAtrasoCercaPadrao.helpText"
                                                            vertical>
                                                            <v-text-field v-model="config.limite_atraso_cerca_padrao"
                                                                type="number" min="1" dense hide-details>
                                                            </v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem
                                                            :title="configTexts.limiteAdiantamentoCercaPadrao.title"
                                                            :subtitle="configTexts.limiteAdiantamentoCercaPadrao.subtitle"
                                                            :helpText="configTexts.limiteAdiantamentoCercaPadrao.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.limite_adiantamento_cerca_padrao"
                                                                type="number" min="1" dense hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>

                                    <v-divider></v-divider>

                                    <v-list-item-group style="margin-top: 5px;">
                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem
                                                            :title="configTexts.monitorAvaliaPessoas.title"
                                                            :subtitle="configTexts.monitorAvaliaPessoas.subtitle"
                                                            :helpText="configTexts.monitorAvaliaPessoas.helpText"
                                                            vertical>
                                                            <v-checkbox
                                                                v-model="config.monitor_avalia_pessoas"
                                                                :true-value="1"
                                                                :false-value="0"
                                                                hide-details
                                                            ></v-checkbox>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem
                                                            :title="configTexts.monitorAplicaAlocacaoPessoas.title"
                                                            :subtitle="configTexts.monitorAplicaAlocacaoPessoas.subtitle"
                                                            :helpText="configTexts.monitorAplicaAlocacaoPessoas.helpText"
                                                            vertical>
                                                            <v-checkbox
                                                                v-model="config.monitor_aplica_alocacao_pessoas"
                                                                :true-value="1"
                                                                :false-value="0"
                                                                :disabled="!config.monitor_avalia_pessoas"
                                                                hide-details
                                                            ></v-checkbox>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>

                                                <v-divider class="my-3"></v-divider>

                                                <!-- Envio automático de QR Code aos passageiros.
                                                     Tudo aqui depende de envio_qrcode_automatico; os
                                                     limites de taxa por método ficam no .env do monitor. -->
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem
                                                            :title="configTexts.envioQrcodeAutomatico.title"
                                                            :subtitle="configTexts.envioQrcodeAutomatico.subtitle"
                                                            :helpText="configTexts.envioQrcodeAutomatico.helpText"
                                                            vertical>
                                                            <v-checkbox
                                                                v-model="config.envio_qrcode_automatico"
                                                                :true-value="1"
                                                                :false-value="0"
                                                                hide-details
                                                            ></v-checkbox>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="3">
                                                        <ConfigItem
                                                            :title="configTexts.envioQrcodeMetodo.title"
                                                            :subtitle="configTexts.envioQrcodeMetodo.subtitle"
                                                            :helpText="configTexts.envioQrcodeMetodo.helpText"
                                                            vertical>
                                                            <v-select
                                                                v-model="config.envio_qrcode_metodo"
                                                                :items="metodosEnvioQrcode"
                                                                item-text="descricao"
                                                                item-value="id_metodo"
                                                                :disabled="!config.envio_qrcode_automatico"
                                                                dense hide-details
                                                            ></v-select>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="3">
                                                        <ConfigItem
                                                            :title="configTexts.envioQrcodeColunaData.title"
                                                            :subtitle="configTexts.envioQrcodeColunaData.subtitle"
                                                            :helpText="configTexts.envioQrcodeColunaData.helpText"
                                                            vertical>
                                                            <v-select
                                                                v-model="config.envio_qrcode_coluna_data"
                                                                :items="colunasDataEnvioQrcode"
                                                                item-text="descricao"
                                                                item-value="id_coluna_data"
                                                                :disabled="!config.envio_qrcode_automatico"
                                                                dense hide-details
                                                            ></v-select>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="3">
                                                        <ConfigItem
                                                            :title="configTexts.envioQrcodeDiasPrimeiroEnvio.title"
                                                            :subtitle="configTexts.envioQrcodeDiasPrimeiroEnvio.subtitle"
                                                            :helpText="configTexts.envioQrcodeDiasPrimeiroEnvio.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.envio_qrcode_dias_primeiro_envio"
                                                                type="number" min="0" dense hide-details
                                                                :disabled="!config.envio_qrcode_automatico"
                                                            ></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="3">
                                                        <ConfigItem
                                                            :title="configTexts.envioQrcodeDiasReenvio.title"
                                                            :subtitle="configTexts.envioQrcodeDiasReenvio.subtitle"
                                                            :helpText="configTexts.envioQrcodeDiasReenvio.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.envio_qrcode_dias_reenvio"
                                                                type="number" min="0" dense clearable hide-details
                                                                :disabled="!config.envio_qrcode_automatico"
                                                            ></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="3">
                                                        <ConfigItem
                                                            :title="configTexts.envioQrcodeMinutosRetentativa.title"
                                                            :subtitle="configTexts.envioQrcodeMinutosRetentativa.subtitle"
                                                            :helpText="configTexts.envioQrcodeMinutosRetentativa.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.envio_qrcode_minutos_retentativa"
                                                                type="number" min="1" dense hide-details
                                                                :disabled="!config.envio_qrcode_automatico"
                                                            ></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="3">
                                                        <ConfigItem
                                                            :title="configTexts.envioQrcodeMaxTentativas.title"
                                                            :subtitle="configTexts.envioQrcodeMaxTentativas.subtitle"
                                                            :helpText="configTexts.envioQrcodeMaxTentativas.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.envio_qrcode_max_tentativas"
                                                                type="number" min="1" dense hide-details
                                                                :disabled="!config.envio_qrcode_automatico"
                                                            ></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem
                                                            :title="configTexts.envioQrcodeFinaisSemana.title"
                                                            :subtitle="configTexts.envioQrcodeFinaisSemana.subtitle"
                                                            :helpText="configTexts.envioQrcodeFinaisSemana.helpText"
                                                            vertical>
                                                            <v-checkbox
                                                                v-model="config.envio_qrcode_finais_semana"
                                                                :true-value="1" :false-value="0"
                                                                :disabled="!config.envio_qrcode_automatico"
                                                                hide-details
                                                            ></v-checkbox>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem
                                                            :title="configTexts.envioQrcodeFeriados.title"
                                                            :subtitle="configTexts.envioQrcodeFeriados.subtitle"
                                                            :helpText="configTexts.envioQrcodeFeriados.helpText"
                                                            vertical>
                                                            <v-checkbox
                                                                v-model="config.envio_qrcode_feriados"
                                                                :true-value="1" :false-value="0"
                                                                :disabled="!config.envio_qrcode_automatico"
                                                                hide-details
                                                            ></v-checkbox>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem
                                                            :title="configTexts.envioQrcodeSemLinhaGrupo.title"
                                                            :subtitle="configTexts.envioQrcodeSemLinhaGrupo.subtitle"
                                                            :helpText="configTexts.envioQrcodeSemLinhaGrupo.helpText"
                                                            vertical>
                                                            <v-checkbox
                                                                v-model="config.envio_qrcode_sem_linha_grupo"
                                                                :true-value="1" :false-value="0"
                                                                :disabled="!config.envio_qrcode_automatico"
                                                                hide-details
                                                            ></v-checkbox>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="6" md="3">
                                                        <ConfigItem
                                                            :title="configTexts.envioQrcodeUnidades.title"
                                                            :subtitle="configTexts.envioQrcodeUnidades.subtitle"
                                                            :helpText="configTexts.envioQrcodeUnidades.helpText"
                                                            vertical>
                                                            <MultiplaEscolha
                                                                ref="envioQrcodeUnidadesSelect"
                                                                lazy
                                                                get-url="getUnidadeslazy"
                                                                text="descricao_unidade"
                                                                value="id_unidade"
                                                                :selected-items.sync="escopoQrcode.unidades"
                                                                can-toggle-all
                                                                :all-matching-selected="!!config.envio_qrcode_todas_unidades"
                                                                @update:allMatchingSelected="setEscopoQrcodeTodos('unidades', $event)"
                                                                :label="$t('nav.registration.units')"
                                                                :disabled="!config.envio_qrcode_automatico"
                                                            />
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="6" md="3">
                                                        <ConfigItem
                                                            :title="configTexts.envioQrcodeClientes.title"
                                                            :subtitle="configTexts.envioQrcodeClientes.subtitle"
                                                            :helpText="configTexts.envioQrcodeClientes.helpText"
                                                            vertical>
                                                            <MultiplaEscolha
                                                                ref="envioQrcodeClientesSelect"
                                                                lazy
                                                                get-url="getClienteslazy"
                                                                text="nome_cliente"
                                                                value="id_cliente"
                                                                :selected-items.sync="escopoQrcode.clientes"
                                                                can-toggle-all
                                                                :all-matching-selected="!!config.envio_qrcode_todos_clientes"
                                                                @update:allMatchingSelected="setEscopoQrcodeTodos('clientes', $event)"
                                                                :label="$t('nav.registration.clients')"
                                                                :disabled="!config.envio_qrcode_automatico"
                                                            />
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="6" md="3">
                                                        <ConfigItem
                                                            :title="configTexts.envioQrcodeEmpresas.title"
                                                            :subtitle="configTexts.envioQrcodeEmpresas.subtitle"
                                                            :helpText="configTexts.envioQrcodeEmpresas.helpText"
                                                            vertical>
                                                            <MultiplaEscolha
                                                                ref="envioQrcodeEmpresasSelect"
                                                                lazy
                                                                get-url="getEmpresaslazy"
                                                                text="razao_social"
                                                                value="id_empresa"
                                                                :selected-items.sync="escopoQrcode.empresas"
                                                                can-toggle-all
                                                                :all-matching-selected="!!config.envio_qrcode_todas_empresas"
                                                                @update:allMatchingSelected="setEscopoQrcodeTodos('empresas', $event)"
                                                                :label="$t('nav.registration.companies')"
                                                                :disabled="!config.envio_qrcode_automatico"
                                                            />
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="6" md="3">
                                                        <ConfigItem
                                                            :title="configTexts.envioQrcodeGrupos.title"
                                                            :subtitle="configTexts.envioQrcodeGrupos.subtitle"
                                                            :helpText="configTexts.envioQrcodeGrupos.helpText"
                                                            vertical>
                                                            <MultiplaEscolha
                                                                ref="envioQrcodeGruposSelect"
                                                                lazy
                                                                get-url="getGruposlazy"
                                                                text="nome"
                                                                value="id_grupo"
                                                                :selected-items.sync="escopoQrcode.grupos"
                                                                can-toggle-all
                                                                :all-matching-selected="!!config.envio_qrcode_todos_grupos"
                                                                @update:allMatchingSelected="setEscopoQrcodeTodos('grupos', $event)"
                                                                :label="$t('nav.registration.groups')"
                                                                :disabled="!config.envio_qrcode_automatico"
                                                            />
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="6" md="3">
                                                        <ConfigItem
                                                            :title="configTexts.envioQrcodeNotificados.title"
                                                            :subtitle="configTexts.envioQrcodeNotificados.subtitle"
                                                            :helpText="configTexts.envioQrcodeNotificados.helpText"
                                                            vertical>
                                                            <MultiplaEscolha
                                                                ref="envioQrcodeNotificadosSelect"
                                                                lazy
                                                                get-url="getUsuarioslazy"
                                                                text="nome_usuario"
                                                                value="id_usuario"
                                                                :selected-items.sync="escopoQrcode.notificados"
                                                                :label="$t('nav.registration.users')"
                                                                :disabled="!config.envio_qrcode_automatico"
                                                            />
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem
                                                            :title="configTexts.minimoEmbarquesAbreViagem.title"
                                                            :subtitle="configTexts.minimoEmbarquesAbreViagem.subtitle"
                                                            :helpText="configTexts.minimoEmbarquesAbreViagem.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.minimo_embarques_abre_viagem"
                                                                type="number" suffix="emb." min="1" dense
                                                                clearable
                                                                hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem
                                                            :title="configTexts.janelaEmbarquesAbreViagem.title"
                                                            :subtitle="configTexts.janelaEmbarquesAbreViagem.subtitle"
                                                            :helpText="configTexts.janelaEmbarquesAbreViagem.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.janela_embarques_abre_viagem_minutos"
                                                                type="number" suffix="min" min="1" dense
                                                                clearable
                                                                :disabled="!config.minimo_embarques_abre_viagem"
                                                                hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem
                                                            :title="configTexts.raioIdealValidacaoCandidatos.title"
                                                            :subtitle="configTexts.raioIdealValidacaoCandidatos.subtitle"
                                                            :helpText="configTexts.raioIdealValidacaoCandidatos.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.raio_ideal_validacao_candidatos"
                                                                type="number" suffix="m" min="1" dense
                                                                hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem
                                                            :title="configTexts.raioMaximoValidacaoCandidatos.title"
                                                            :subtitle="configTexts.raioMaximoValidacaoCandidatos.subtitle"
                                                            :helpText="configTexts.raioMaximoValidacaoCandidatos.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.raio_maximo_validacao_candidatos"
                                                                type="number" suffix="m" min="1" dense
                                                                hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem
                                                            :title="configTexts.diasDownloadPrecandidatos.title"
                                                            :subtitle="configTexts.diasDownloadPrecandidatos.subtitle"
                                                            :helpText="configTexts.diasDownloadPrecandidatos.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.dias_download_precandidatos_pos_finalizacao"
                                                                type="number" min="0" dense clearable
                                                                hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem
                                                            :title="configTexts.tempoMaximoPermanenciaLinha.title"
                                                            :subtitle="configTexts.tempoMaximoPermanenciaLinha.subtitle"
                                                            :helpText="configTexts.tempoMaximoPermanenciaLinha.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.tempo_maximo_permanencia_linha_minutos"
                                                                type="number" suffix="min" min="1" dense
                                                                clearable
                                                                hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem
                                                            :title="configTexts.velocidadeMediaEstimativa.title"
                                                            :subtitle="configTexts.velocidadeMediaEstimativa.subtitle"
                                                            :helpText="configTexts.velocidadeMediaEstimativa.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.velocidade_media_estimativa_kmh"
                                                                type="number" suffix="km/h" min="1" dense
                                                                clearable
                                                                hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem
                                                            :title="configTexts.maxLinhasRetornoValidacao.title"
                                                            :subtitle="configTexts.maxLinhasRetornoValidacao.subtitle"
                                                            :helpText="configTexts.maxLinhasRetornoValidacao.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.max_linhas_retorno_validacao"
                                                                type="number" min="1" max="20" dense
                                                                clearable
                                                                hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="5">
                                                        <ConfigItem :title="configTexts.unitCenterRadius.title"
                                                            :subtitle="configTexts.unitCenterRadius.subtitle"
                                                            :helpText="configTexts.unitCenterRadius.helpText" vertical>
                                                            <v-text-field
                                                                v-model="config.raio_centro_unidades"
                                                                type="number" suffix="m" min="1" dense
                                                                hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="7">
                                                        <ConfigItem :title="configTexts.percentualSimilaridadeMinimaRotas.title"
                                                            :subtitle="configTexts.percentualSimilaridadeMinimaRotas.subtitle"
                                                            :helpText="configTexts.percentualSimilaridadeMinimaRotas.helpText" vertical>
                                                            <v-text-field v-model="config.percentual_similaridade_minima_rotas"
                                                                type="number" suffix="%" min="0" max="100" dense hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem :title="configTexts.tempoBuscaFixoParada.title"
                                                            :subtitle="configTexts.tempoBuscaFixoParada.subtitle"
                                                            :helpText="configTexts.tempoBuscaFixoParada.helpText" vertical>
                                                            <v-text-field
                                                                v-model="config.tempo_busca_fixo_parada_segundos"
                                                                type="number" suffix="s" min="0" max="3600" dense
                                                                hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem :title="configTexts.tempoBuscaPorPassageiro.title"
                                                            :subtitle="configTexts.tempoBuscaPorPassageiro.subtitle"
                                                            :helpText="configTexts.tempoBuscaPorPassageiro.helpText" vertical>
                                                            <v-text-field
                                                                v-model="config.tempo_busca_por_passageiro_segundos"
                                                                type="number" suffix="s" min="0" max="3600" dense
                                                                hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem :title="configTexts.tempoDesembarqueFixoParada.title"
                                                            :subtitle="configTexts.tempoDesembarqueFixoParada.subtitle"
                                                            :helpText="configTexts.tempoDesembarqueFixoParada.helpText" vertical>
                                                            <v-text-field
                                                                v-model="config.tempo_desembarque_fixo_parada_segundos"
                                                                type="number" suffix="s" min="0" max="3600" dense
                                                                hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem :title="configTexts.tempoDesembarquePorPassageiro.title"
                                                            :subtitle="configTexts.tempoDesembarquePorPassageiro.subtitle"
                                                            :helpText="configTexts.tempoDesembarquePorPassageiro.helpText" vertical>
                                                            <v-text-field
                                                                v-model="config.tempo_desembarque_por_passageiro_segundos"
                                                                type="number" suffix="s" min="0" max="3600" dense
                                                                hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem
                                                            :title="configTexts.raioAglomeracaoRejeitados.title"
                                                            :subtitle="configTexts.raioAglomeracaoRejeitados.subtitle"
                                                            :helpText="configTexts.raioAglomeracaoRejeitados.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.raio_aglomeracao_rejeitados"
                                                                type="number" suffix="m" min="1" dense
                                                                hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem :title="configTexts.geocodingApiRouting.title"
                                                            :subtitle="configTexts.geocodingApiRouting.subtitle"
                                                            :helpText="configTexts.geocodingApiRouting.helpText" vertical>
                                                            <v-radio-group
                                                                v-model="config.api_geocodificacao_roteirizacao"
                                                                hide-details
                                                                class="mt-0 pt-0"
                                                            >
                                                                <v-radio
                                                                    :label="$t('config.system_parameters.geocoding_api_routing.options.google')"
                                                                    value="google"
                                                                ></v-radio>
                                                                <v-radio
                                                                    :label="$t('config.system_parameters.geocoding_api_routing.options.here')"
                                                                    value="here"
                                                                ></v-radio>
                                                            </v-radio-group>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <ConfigItem :title="configTexts.tempoCarenciaVeiculos.title"
                                                            :subtitle="configTexts.tempoCarenciaVeiculos.subtitle"
                                                            :helpText="configTexts.tempoCarenciaVeiculos.helpText" vertical>
                                                            <v-text-field
                                                                v-model="config.tempo_carencia_veiculos"
                                                                type="number"
                                                                suffix="min"
                                                                min="0"
                                                                dense
                                                                hide-details
                                                            ></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>

                                    <template v-if="canManageLimitesApiExternas">
                                        <v-divider></v-divider>

                                        <v-list-item-group style="margin-top: 5px;">
                                            <v-list-item inactive>
                                                <v-list-item-content>
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <ConfigItem 
                                                                :title="configTexts.externalApiLimits.title"
                                                                vertical
                                                            >
                                                                <div v-if="loadingLimitesApiExternas" class="pa-4 text-center">
                                                                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                                                    <span class="ml-2">{{ $t('system.messages.loading') }}</span>
                                                                </div>
                                                                <v-expansion-panels v-else accordion>
                                                                    <v-expansion-panel
                                                                        v-for="grupo in limitesApiExternasByOperador"
                                                                        :key="grupo.operador"
                                                                    >
                                                                        <v-expansion-panel-header>
                                                                            {{ grupo.operador }}
                                                                        </v-expansion-panel-header>
                                                                        <v-expansion-panel-content>
                                                                            <v-row
                                                                                v-for="item in grupo.servicos"
                                                                                :key="item.id_servico_externo"
                                                                                align="center"
                                                                                class="mb-2"
                                                                            >
                                                                                <v-col cols="12" sm="4">
                                                                                    <span class="body-2">{{ item.servico_api_externa }}</span>
                                                                                </v-col>
                                                                                <v-col cols="12" sm="3">
                                                                                    <v-text-field
                                                                                        v-model.number="item.limite_chamadas"
                                                                                        type="number"
                                                                                        min="0"
                                                                                        dense
                                                                                        hide-details
                                                                                        :label="$t('config.system_parameters.external_api_limits.call_limit')"
                                                                                    ></v-text-field>
                                                                                </v-col>
                                                                                <v-col cols="12" sm="2">
                                                                                    <v-chip
                                                                                        v-if="Number(item.limite_excedido) === 1"
                                                                                        small
                                                                                        color="error"
                                                                                        text-color="white"
                                                                                    >
                                                                                        {{ $t('config.system_parameters.external_api_limits.limit_exceeded') }}
                                                                                    </v-chip>
                                                                                </v-col>
                                                                                <v-col cols="12" sm="3">
                                                                                    <v-text-field
                                                                                        v-model.number="item.dia_refresh"
                                                                                        type="number"
                                                                                        min="1"
                                                                                        max="31"
                                                                                        dense
                                                                                        hide-details
                                                                                        :label="$t('config.system_parameters.external_api_limits.refresh_day')"
                                                                                    ></v-text-field>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-expansion-panel-content>
                                                                    </v-expansion-panel>
                                                                </v-expansion-panels>
                                                            </ConfigItem>
                                                        </v-col>
                                                    </v-row>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </template>

                                    <v-divider></v-divider>

                                    <v-list-item-group style="margin-top: 5px;">
                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="12" sm="4">
                                                        <ConfigItem :title="configTexts.anulaViagemPorPassagemCerca.title"
                                                            :subtitle="configTexts.anulaViagemPorPassagemCerca.subtitle"
                                                            :helpText="configTexts.anulaViagemPorPassagemCerca.helpText" vertical>
                                                            <v-checkbox v-model="config.anula_viagem_por_passagem_cerca"
                                                                hide-details></v-checkbox>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="4" v-if="config.anula_viagem_por_passagem_cerca">
                                                        <ConfigItem :title="configTexts.minimoCercasAnulaViagem.title"
                                                            :subtitle="configTexts.minimoCercasAnulaViagem.subtitle"
                                                            :helpText="configTexts.minimoCercasAnulaViagem.helpText" vertical>
                                                            <v-text-field v-model="config.minimo_cercas_anula_viagem"
                                                                type="number" min="1" dense hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="4" v-if="config.anula_viagem_por_passagem_cerca">
                                                        <ConfigItem :title="configTexts.tempoMinimoAnulaViagem.title"
                                                            :subtitle="configTexts.tempoMinimoAnulaViagem.subtitle"
                                                            :helpText="configTexts.tempoMinimoAnulaViagem.helpText" vertical>
                                                            <v-text-field v-model="config.tempo_minimo_anula_viagem"
                                                                type="number" min="1" dense hide-details></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </template>

                                <template v-if="selectedSection === 1">
                                    <v-list-item-group style="margin-top: 5px;">
                                        <v-row>
                                            <v-col cols="12" sm="5">
                                                <ConfigItem :title="configTexts.roletaObrigatoria.title"
                                                    :subtitle="configTexts.roletaObrigatoria.subtitle"
                                                    :helpText="configTexts.roletaObrigatoria.helpText" vertical>
                                                    <v-checkbox v-model="config.monitor_roleta_obrigatoria"
                                                        hide-details></v-checkbox>
                                                </ConfigItem>
                                            </v-col>
                                            <v-col cols="12" sm="5">
                                                <ConfigItem :title="configTexts.odometroObrigatorio.title"
                                                    :subtitle="configTexts.odometroObrigatorio.subtitle"
                                                    :helpText="configTexts.odometroObrigatorio.helpText" vertical>
                                                    <v-checkbox v-model="config.monitor_odometro_obrigatorio"
                                                        hide-details></v-checkbox>
                                                </ConfigItem>
                                            </v-col>
                                        </v-row>
                                    </v-list-item-group>

                                    <v-divider></v-divider>

                                    <v-list-item-group style="margin-top: 5px;">
                                        <v-row>
                                            <v-col cols="12" sm="12">
                                                <ConfigItem :title="configTexts.ligarFiltrosRoleta.title"
                                                    :subtitle="configTexts.ligarFiltrosRoleta.subtitle"
                                                    :helpText="configTexts.ligarFiltrosRoleta.helpText" vertical>
                                                    <v-checkbox v-model="config.ligar_filtros_roleta"
                                                        hide-details></v-checkbox>
                                                </ConfigItem>
                                            </v-col>
                                        </v-row>
                                        <v-list-item inactive v-if="!!config.ligar_filtros_roleta">
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="12" sm="10" md="4">
                                                        <ConfigItem :title="configTexts.diferencaRoleta.title"
                                                            :subtitle="configTexts.diferencaRoleta.subtitle"
                                                            :helpText="configTexts.diferencaRoleta.helpText" vertical>
                                                            <v-text-field v-model="config.porcentagem_diferenca_roleta"
                                                                type="number" suffix="%" min="0" max="100"
                                                                hide-spin-buttons></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="10" md="4">
                                                        <ConfigItem :title="configTexts.digitosRoleta.title"
                                                            :subtitle="configTexts.digitosRoleta.subtitle"
                                                            :helpText="configTexts.digitosRoleta.helpText" vertical>
                                                            <v-text-field v-model="config.numero_digitos_roleta"
                                                                type="number" min="0" hide-spin-buttons></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>

                                    <v-divider></v-divider>

                                    <v-list-item-group style="margin-top: 5px;">
                                        <v-row>
                                            <v-col cols="12" sm="5">
                                                <ConfigItem :title="configTexts.ligarFiltrosOdometro.title"
                                                    :subtitle="configTexts.ligarFiltrosOdometro.subtitle"
                                                    :helpText="configTexts.ligarFiltrosOdometro.helpText" vertical>
                                                    <v-checkbox v-model="config.ligar_filtros_odometro"
                                                        hide-details></v-checkbox>
                                                </ConfigItem>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-list-item inactive v-if="!!config.ligar_filtros_odometro">
                                                <v-col cols="12" sm="10" md="4">
                                                    <ConfigItem :title="configTexts.diferencaOdometro.title"
                                                        :subtitle="configTexts.diferencaOdometro.subtitle"
                                                        :helpText="configTexts.diferencaOdometro.helpText" vertical>
                                                        <v-text-field v-model="config.porcentagem_diferenca_odometro"
                                                            type="number" suffix="%" min="0" max="100"
                                                            hide-spin-buttons></v-text-field>
                                                    </ConfigItem>
                                                </v-col>
                                            </v-list-item>
                                        </v-row>
                                    </v-list-item-group>

                                </template>

                                <template v-if="selectedSection === 2">
                                    <v-list-item-group style="margin-top: 5px;">
                                        <v-list-item v-for="(tipo, i) in tiposNotificacoes" :key="i" inactive class="align-start">
                                    <v-list-item-content class="pa-0" style="width: 100%; max-width: 100%;">
                                        <v-container fluid class>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-list-item-title class="text-h8">{{ tipo.descricao_tipo_notificacao }}</v-list-item-title>
                                                </v-col>
                                            </v-row>
                                            <v-row align="center">
                                                <v-col cols="12" sm="6" md="3">
                                                    <v-switch
                                                        v-model="tipo.show_relatorio"
                                                        class="ma-0"
                                                        :label="$t('config.notifications.enabled')"
                                                        hide-details
                                                    ></v-switch>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="3">
                                                    <v-switch
                                                        v-model="tipo.show_alerta"
                                                        class="ma-0"
                                                        :label="$t('config.notifications.alert')"
                                                        hide-details
                                                    ></v-switch>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="3">
                                                    <v-menu offset-y>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                :color="tipo.cor"
                                                                dark
                                                                v-on="on"
                                                            >
                                                                {{ $t('config.notifications.color') }}
                                                            </v-btn>
                                                        </template>
                                                        <v-color-picker
                                                            v-model="tipo.cor"
                                                            hide-canvas
                                                            hide-inputs
                                                            hide-sliders
                                                            show-swatches
                                                            class="mx-auto"
                                                            mode="hexa"
                                                        ></v-color-picker>
                                                    </v-menu>
                                                </v-col>
                                                <v-col cols="12" sm="5" md="3">
                                                    <v-text-field
                                                        v-model="tipo.hierarquia_notificacao"
                                                        :label="$t('config.notifications.hierarchy')"
                                                        type="number"
                                                        min="0"
                                                        max="999999"
                                                        hide-spin-buttons
                                                        dense
                                                        hide-details
                                                    >
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="12">
                                                    <v-divider class="mt-2"></v-divider>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                                </template>

                                <template v-if="selectedSection === 3">
                                    <v-list-item-group style="margin-top: 5px;">
                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="12" sm="10" md="4">
                                                        <ConfigItem :title="configTexts.atualizacaoNotificacoes.title"
                                                            :subtitle="configTexts.atualizacaoNotificacoes.subtitle"
                                                            :helpText="configTexts.atualizacaoNotificacoes.helpText"
                                                            vertical>
                                                            <v-text-field
                                                                v-model="config.tempo_atualizacao_notificacoes"
                                                                type="number" suffix="s" min="60" max="3600"
                                                                hide-spin-buttons></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="10" md="4">
                                                        <ConfigItem :title="configTexts.atualizacaoLinhas.title"
                                                            :subtitle="configTexts.atualizacaoLinhas.subtitle"
                                                            :helpText="configTexts.atualizacaoLinhas.helpText" vertical>
                                                            <v-text-field v-model="config.tempo_atualizacao_linhas"
                                                                type="number" suffix="s" min="120" max="3600"
                                                                hide-spin-buttons></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                    <v-col cols="12" sm="10" md="4">
                                                        <ConfigItem :title="configTexts.atualizacaoGrade.title"
                                                            :subtitle="configTexts.atualizacaoGrade.subtitle"
                                                            :helpText="configTexts.atualizacaoGrade.helpText" vertical>
                                                            <v-text-field v-model="config.tempo_atualizacao_grade"
                                                                type="number" suffix="s" min="120" max="3600"
                                                                hide-spin-buttons></v-text-field>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>

                                    <v-divider></v-divider>
                                </template>

                                <template v-if="selectedSection === 4">
                                    <v-list-item-group class="config-relatorios-group" style="margin-top: 5px;">
                                        <v-list-item inactive :ripple="false">
                                            <v-list-item-content>
                                                <div class="d-flex align-center mb-4">
                                                    <v-icon color="primary" class="mr-2">mdi-cog-sync-outline</v-icon>
                                                    <span class="text-subtitle-1 font-weight-medium">{{ $t('config.reports.equipment_maintenance') }}</span>
                                                </div>

                                                <v-card v-for="grupo in relManutencaoGruposLimites" :key="grupo.key"
                                                    outlined class="pa-4 mb-4 config-relatorios-limites-card" style="border-radius: 12px;">
                                                    <v-chip small label :color="grupo.color" dark class="mb-3 px-3 font-weight-bold">
                                                        {{ grupo.label }}
                                                    </v-chip>
                                                    <v-row v-for="limite in limitesRelManutencaoGrupo(grupo.key)"
                                                        :key="`${limite.tipo_aba}-${limite.id_tipo_equipamento}`"
                                                        dense align="center" class="mb-1 config-relatorios-limite-row">
                                                        <v-col cols="12" class="font-weight-medium config-relatorios-limite-nome">
                                                            {{ nomeTipoEquipamento(limite.id_tipo_equipamento) }}
                                                            <span class="text-caption grey--text">({{ limite.id_tipo_equipamento }})</span>
                                                        </v-col>
                                                        <v-col cols="12" sm="6" md="3">
                                                            <v-text-field v-model.number="limite.limite_envio"
                                                                :label="configTexts.limiteEnvio.title"
                                                                type="number" suffix="%" min="0" max="100" outlined dense
                                                                :rules="[validarLimitePercentual]" hide-spin-buttons></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" sm="6" md="3">
                                                            <v-text-field v-model.number="limite.limite_posicoes_validas"
                                                                :label="configTexts.limitePosicoesValidas.title"
                                                                type="number" suffix="%" min="0" max="100" outlined dense
                                                                :rules="[validarLimitePercentual]" hide-spin-buttons></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" sm="6" md="3">
                                                            <v-text-field v-model.number="limite.limite_fora_ordem"
                                                                :label="configTexts.limiteForaOrdem.title"
                                                                type="number" suffix="%" min="0" max="100" outlined dense
                                                                :rules="[validarLimitePercentual]" hide-spin-buttons></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12" sm="6" md="3">
                                                            <v-text-field v-model.number="limite.limite_delay"
                                                                :label="configTexts.limiteDelay.title"
                                                                type="number" suffix="%" min="0" max="100" outlined dense
                                                                :rules="[validarLimitePercentual]" hide-spin-buttons></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-card>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>

                                    <v-list-item-group style="margin-top: 5px;">
                                        <v-list-item inactive :ripple="false">
                                            <v-list-item-content>
                                                <div class="d-flex align-center mb-4">
                                                    <v-icon color="primary" class="mr-2">mdi-access-point-network</v-icon>
                                                    <span class="text-subtitle-1 font-weight-medium">{{ $t('config.reports.other_equipment') }}</span>
                                                </div>
                                                <v-card outlined class="pa-4" style="border-radius: 12px;">
                                                    <v-row dense>
                                                        <v-col cols="4" class="config-hikvision-limit">
                                                            <div class="config-hikvision-limit-title">
                                                                {{ configTexts.limiteHorasAtualizacaoEquipamento.title }}
                                                            </div>
                                                            <v-text-field v-model="config.limite_horas_atualizacao_equipamento"
                                                                :aria-label="configTexts.limiteHorasAtualizacaoEquipamento.title"
                                                                type="number" suffix="h" min="1" outlined dense
                                                                hide-spin-buttons></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-card>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>

                                    <v-list-item-group style="margin-top: 5px;">
                                        <v-list-item inactive :ripple="false">
                                            <v-list-item-content>
                                                <div class="d-flex align-center mb-4">
                                                    <v-icon color="primary" class="mr-2">mdi-view-grid-outline</v-icon>
                                                    <span class="text-subtitle-1 font-weight-medium">Abas do relatório de manutenção</span>
                                                </div>
                                                <div class="text-caption grey--text text--darken-1 mt-n2 mb-3">
                                                    Também definem as abas da tela de Equipamentos: Validadores → Validadores; Rastreadores e Validadores/Rastreadores/Bilhetagem → Rastreadores; DVR e tipos sem grupo → Outros.
                                                </div>
                                                <v-card outlined class="pa-4" style="border-radius: 12px;">
                                                    <v-row dense>
                                                        <v-col
                                                            v-for="grupo in relManutencaoTipoAbas"
                                                            :key="grupo.key"
                                                            cols="12"
                                                            sm="6"
                                                        >
                                                            <div class="config-relatorios-aba-item">
                                                                <div class="config-relatorios-aba-titulo">{{ grupo.label }}</div>
                                                                <div class="config-relatorios-aba-subtitulo">{{ grupo.subtitle }}</div>
                                                                <v-autocomplete
                                                                    v-model="relManutencaoTiposEquipamentos[grupo.key]"
                                                                    :items="tiposEquipamentos"
                                                                    item-text="nome_tipo_equipamento"
                                                                    item-value="id_tipo_equipamento"
                                                                    multiple
                                                                    chips
                                                                    small-chips
                                                                    clearable
                                                                    outlined
                                                                    dense
                                                                    hide-details
                                                                    @change="sincronizarLimitesRelManutencao"
                                                                ></v-autocomplete>
                                                            </div>
                                                        </v-col>
                                                    </v-row>
                                                </v-card>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>

                                    <v-divider></v-divider>
                                </template>

                                <template v-if="selectedSection === 5">
                                    <v-row>
                                        <v-col cols="12" sm="10" md="6">
                                            <v-autocomplete
                                                v-model="selectedIdRecurso"
                                                :items="telasComTabela"
                                                :item-text="getTelaLabel"
                                                item-value="id_recurso"
                                                :label="$t('config.tables.selectScreen')"
                                                :hint="$t('config.tables.selectScreenHint')"
                                                persistent-hint
                                                clearable
                                            ></v-autocomplete>
                                        </v-col>
                                    </v-row>

                                    <v-alert
                                        v-if="selectedIdRecurso && !tabelasDoRecursoSelecionado.length"
                                        type="info"
                                        text
                                        dense
                                        class="mt-2"
                                    >
                                        {{ $t('config.tables.noTableForScreen') }}
                                    </v-alert>

                                    <merus-data-table v-for="(tabela, t) in tabelasDoRecursoSelecionado"
                                        :key="`TABLE-${tabela.id_tabela}-${t}`"
                                        :headers="headersConfigTabelasWithProperties"
                                        :items="getHeadersByTable(tabela.id_tabela)"
                                        item-key="id_header" sort-by="column_order" v-model="headersSelected"
                                        disable-pagination hide-default-footer show-select dense checkbox-color="black"
                                        class="elevation-7" :locale="$i18n.locale"
                                        style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px"
                                        :loading-text="$t('config.tables.loading')"
                                        @item-selected="(row, value) => toggleHeader(row, value)"
                                        @toggle-select-all="(rows, value) => toggleAll(rows, value)">
                                        <template v-slot:toolbar>
                                            <CadastroToolbar :title="tabela.descricao" :token="token"
                                                :items="getHeadersByTable(tabela.id_tabela)"
                                                hide-search />
                                        </template>

                                        <template v-slot:item.order="{ item }">
                                            <v-btn icon small color="green" @click="ordenar(item, 'up')"
                                                :disabled="item.column_order === 1">
                                                <v-icon>mdi-chevron-up</v-icon>
                                            </v-btn>
                                            <v-btn icon small color="red" @click="ordenar(item, 'down')"
                                                :disabled="item.column_order === headers.filter((h) => h.id_tabela === tabela.id_tabela).length">
                                                <v-icon>mdi-chevron-down</v-icon>
                                            </v-btn>
                                        </template>

                                        <template v-slot:item.label="{ item }">
                                            <v-text-field
                                                v-model="item.label"
                                                dense
                                                hide-details
                                                :placeholder="item.text"
                                            ></v-text-field>
                                        </template>

                                        <template v-slot:item.to_export="{ item }">
                                            <v-checkbox
                                                v-model="item.to_export"
                                                :true-value="1"
                                                :false-value="0"
                                                hide-details
                                                class="mt-0 pt-0"
                                                @click.stop
                                            ></v-checkbox>
                                        </template>

                                    </merus-data-table>

                                    <v-divider></v-divider>
                                </template>

                                <template v-if="selectedSection === 6">
                                    <v-card-title>
                                        <strong>{{ $t('config.tables.google_chat.title') }}</strong>
                                    </v-card-title>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="10" md="6">
                                                <v-select v-model="config.space_id_padrao_googlechat" :items="spaces"
                                                    item-text="displayName" item-value="spaceId"
                                                    :label="$t('config.tables.google_chat.default_notification_space')"
                                                    clearable>
                                                </v-select>
                                            </v-col>
                                            <v-col cols="12" sm="10" md="6">
                                                <v-checkbox v-model="config.enviar_msg_direta_googlechat"
                                                    :label="$t('config.tables.google_chat.direct_message')"
                                                    color="primary">
                                                </v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <merus-data-table :headers="headersSpaces" :items="spaces"
                                                    :loading="loading" :default-multi-sort="defaultSort"
                                                    :loading-text="$t('system.messages.loading')"
                                                    @update:displayedItems="displayedItemsForExportSpaces = $event">
                                                    <template v-slot:toolbar>
                                                        <CadastroToolbar
                                                            :title="$t('config.tables.google_chat.spaces_title')"
                                                            :token="token" :items="displayedItemsForExportSpaces !== null ? displayedItemsForExportSpaces : spaces" :csv-title="$t('config.tables.google_chat.spaces_title')"
                                                            :pdf-title="$t('config.tables.google_chat.spaces_title')"
                                                            :pdf-headers="headersSpaces" pdf-filename="spaces"
                                                            hide-search>
                                                        </CadastroToolbar>
                                                    </template>

                                                    <template v-slot:item.spaceUri="{ item }">
                                                        <a :href="item.spaceUri" target="_blank"
                                                            rel="noopener noreferrer">{{ item.spaceUri }}</a>
                                                    </template>
                                                </merus-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                    <v-divider></v-divider>
                                </template>

                                <template v-if="selectedSection === 7">
                                    <v-list-item-group multiple v-if="!loadingTicketCampos">
                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <span class="body-2 grey--text text--darken-1">{{ $t('config.ticketCreationFields.subtitle') }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <strong>{{ $t('config.ticketCreationFields.screen_criados') }}</strong>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col v-for="item in ticketCamposCriacaoCriados" :key="'criados-' + item.id" cols="12" sm="6" md="4">
                                                        <ConfigItem :title="getCampoLabel(item.campo)" vertical>
                                                            <v-checkbox v-model="item.ativo" :true-value="1" :false-value="0" hide-details color="primary"></v-checkbox>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>

                                    <v-divider></v-divider>

                                    <v-list-item-group multiple v-if="!loadingTicketCampos">
                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <strong>{{ $t('config.ticketCreationFields.screen_cliente') }}</strong>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col v-for="item in ticketCamposCriacaoCliente" :key="'cliente-' + item.id" cols="12" sm="6" md="4">
                                                        <ConfigItem :title="getCampoLabel(item.campo)" vertical>
                                                            <v-checkbox v-model="item.ativo" :true-value="1" :false-value="0" hide-details color="primary"></v-checkbox>
                                                        </ConfigItem>
                                                    </v-col>
                                                </v-row>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>

                                    <div v-if="loadingTicketCampos" class="pa-4 text-center">
                                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                        <span class="ml-2">{{ $t('system.messages.loading') }}</span>
                                    </div>

                                    <v-divider></v-divider>
                                </template>

                                <template v-if="selectedSection === 8 && podeVerStatusTickets">
                                    <CRUDStatusTickets embedded />
                                </template>

                                <template v-if="selectedSection === 9">
                                    <v-list-item inactive>
                                        <v-list-item-content>
                                            <v-col cols="12">
                                                <span class="body-2 grey--text text--darken-1">{{ $t('config.ticketDetailFields.subtitle') }}</span>
                                            </v-col>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item-group multiple v-if="!loadingTicketCamposDetalhe">
                                        <div v-for="(screenKey, idx) in ticketDetailScreens" :key="'det-' + screenKey">
                                            <v-list-item inactive>
                                                <v-list-item-content>
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <strong>{{ $t('config.ticketDetailFields.screen_' + screenKey) }}</strong>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col v-for="item in ticketCamposDetalheByScreen(screenKey)" :key="'det-' + screenKey + '-' + item.id" cols="12" sm="6" md="4">
                                                            <ConfigItem :title="getCampoDetalheLabel(item.campo)" vertical>
                                                                <v-checkbox v-model="item.ativo" :true-value="1" :false-value="0" hide-details color="primary"></v-checkbox>
                                                            </ConfigItem>
                                                        </v-col>
                                                    </v-row>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-divider v-if="idx < ticketDetailScreens.length - 1"></v-divider>
                                        </div>
                                    </v-list-item-group>
                                    <div v-if="loadingTicketCamposDetalhe" class="pa-4 text-center">
                                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                        <span class="ml-2">{{ $t('system.messages.loading') }}</span>
                                    </div>
                                    <v-divider></v-divider>
                                    <v-list-item inactive>
                                        <v-list-item-content>
                                            <v-row>
                                                <v-col cols="12">
                                                    <strong>{{ $t('ticketSuporteFluxo.emailsGruposTitulo') }}</strong>
                                                    <div class="body-2 grey--text text--darken-1">{{ $t('ticketSuporteFluxo.emailsGruposHint') }}</div>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col v-for="grupo in gruposSolucionadores" :key="'grupo-' + grupo.id_equipe" cols="12" md="6">
                                                    <v-text-field
                                                        v-model="grupo.email_encaminhamento"
                                                        :label="grupo.nome_equipe"
                                                        :rules="[emailsGrupoRule]"
                                                        clearable
                                                        dense
                                                        outlined
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider></v-divider>
                                </template>

                                <template v-if="selectedSection === 10">
                                    <StatusVeiculosOperacaoMapPreview
                                        v-if="statusVeiculosOperacao.length > 0"
                                        :key="previewStatusMapKey"
                                        :status-list="statusVeiculosOperacao"
                                    />
                                    <v-list-item-group style="margin-top: 5px;">
                                        <v-list-item v-for="(status, i) in statusVeiculosOperacao" :key="i" inactive class="align-start">
                                            <v-list-item-content class="pa-0" style="width: 100%; max-width: 100%;">
                                                <v-container fluid>
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-list-item-title class="text-h8">{{ status.descricao }}</v-list-item-title>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row align="center">
                                                        <v-col cols="12" sm="6" md="3">
                                                            <v-switch
                                                                v-model="status.ativo"
                                                                class="ma-0"
                                                                :true-value="1"
                                                                :false-value="0"
                                                                :label="$t('config.vehicleOperationStatus.ativo')"
                                                                hide-details
                                                            ></v-switch>
                                                        </v-col>
                                                        <v-col cols="12" sm="6" md="3">
                                                            <v-switch
                                                                v-model="status.visivel"
                                                                class="ma-0"
                                                                :true-value="1"
                                                                :false-value="0"
                                                                :label="$t('config.vehicleOperationStatus.visible')"
                                                                hide-details
                                                            ></v-switch>
                                                        </v-col>
                                                        <v-col cols="12" sm="6" md="3">
                                                            <v-menu offset-y>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn
                                                                        :color="status.cor"
                                                                        dark
                                                                        v-on="on"
                                                                    >
                                                                        {{ $t('config.vehicleOperationStatus.color') }}
                                                                    </v-btn>
                                                                </template>
                                                                <v-color-picker
                                                                    v-model="status.cor"
                                                                    hide-canvas
                                                                    hide-inputs
                                                                    hide-sliders
                                                                    show-swatches
                                                                    class="mx-auto"
                                                                    mode="hexa"
                                                                ></v-color-picker>
                                                            </v-menu>
                                                        </v-col>
                                                        <v-col cols="12" sm="5" md="3">
                                                            <v-text-field
                                                                v-model="status.prioridade"
                                                                :label="$t('config.vehicleOperationStatus.priority')"
                                                                type="number"
                                                                min="0"
                                                                max="999999"
                                                                hide-spin-buttons
                                                                dense
                                                                hide-details
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row dense>
                                                        <v-col cols="12">
                                                            <v-divider class="mt-2"></v-divider>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </template>

                                <template v-if="selectedSection === 11">
                                    <v-list-item inactive>
                                        <v-list-item-content>
                                            <v-col cols="12">
                                                <span class="body-2 grey--text text--darken-1">{{ $t('config.businessHours.subtitle') }}</span>
                                            </v-col>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item inactive>
                                        <v-list-item-content>
                                            <v-row v-for="dia in diasHorasUteis" :key="'hora-util-' + dia.key" align="center">
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ dia.text }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field
                                                    v-model="config['hora_util_inicio_' + dia.key]" :label="$t('config.businessHours.start')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo clearable
                                                    :rules="[horarioUtilRule]"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field
                                                    v-model="config['hora_util_fim_' + dia.key]" :label="$t('config.businessHours.end')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo clearable
                                                    :rules="[horarioUtilRule, horarioUtilFimRule(dia.key)]"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="4" md="4">
                                                    <v-icon v-if="!isDiaUtil(dia.key)" color="grey" small>mdi-minus</v-icon>
                                                    <v-icon v-else color="green" small>mdi-clock-outline</v-icon>
                                                    <span style="margin-left: 5px; font-size: 12px;">{{ isDiaUtil(dia.key) ? $t('config.businessHours.businessDay') : $t('config.businessHours.nonBusinessDay') }}</span>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                                <template v-if="selectedSection === 12">
                                    <v-list-item inactive>
                                        <v-list-item-content>
                                            <v-col cols="12">
                                                <span class="body-2 grey--text text--darken-1">{{ $t('config.trip_audit.subtitle') }}</span>
                                            </v-col>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item inactive>
                                        <v-list-item-content>
                                            <v-row>
                                                <v-col cols="12" md="8">
                                                    <ConfigItem :title="configTexts.auditoriaGuiasPorViagem.title"
                                                        :subtitle="configTexts.auditoriaGuiasPorViagem.subtitle"
                                                        :helpText="configTexts.auditoriaGuiasPorViagem.helpText" vertical>
                                                        <v-checkbox v-model="config.auditoria_guias_por_viagem" hide-details></v-checkbox>
                                                    </ConfigItem>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider></v-divider>
                                    <v-list-item inactive>
                                        <v-list-item-content>
                                            <v-row>
                                                <v-col v-for="p in parametrosAuditoria" :key="p.campo" cols="12" sm="6" md="4">
                                                    <ConfigItem :title="p.titulo" :subtitle="p.subtitulo" vertical>
                                                        <v-text-field v-model="config[p.campo]" type="number" :min="p.min" :max="p.max"
                                                            dense outlined hide-details="auto" class="mt-2" :suffix="p.unidade"
                                                            :placeholder="p.dica" persistent-placeholder
                                                            :rules="[regraParametroAuditoria(p)]"></v-text-field>
                                                    </ConfigItem>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-list>
                        </v-card-text>
                        <v-card-actions v-if="!isTicketStatusSection">
                            <v-spacer></v-spacer>
                            <v-btn color="primary" class="white--text" @click="cancel">{{ $t('button.cancel') }}</v-btn>
                            <v-btn color="primary" class="white--text" @click="save">{{ $t('button.save') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

    </v-container>
</template>

<script>
import apiController from "@/utils/apiController";
import { mapMutations } from "vuex";
import MerusDataTable from "./Tables/MerusDataTable.vue"
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue"
import EventBus from "@/utils/eventBus"
import ConfigItem from "./ConfigItem.vue"
import translateDbField from "@/utils/translateDbField";
import StatusVeiculosOperacaoMapPreview from "./StatusVeiculosOperacaoMapPreview.vue";
import MultiplaEscolha from "./Selects/MultiplaEscolha.vue";
import CRUDStatusTickets from "./tickets/CRUDStatusTickets.vue";

/**
 * Parâmetros da auditoria de viagens (colunas auditoria_* de configuracoes). Vazio = padrão do monitor
 * (monitor/auditoria). Limites espelhados em api/routers/config/updateconfig.js.
 */
const PARAMETROS_AUDITORIA = [
    { campo: 'auditoria_desvio_max_associacao_min', min: 1, max: 720, padrao: 60, unidade: 'minutes' },
    { campo: 'auditoria_tolerancia_pontualidade_min', min: 1, max: 60, padrao: 5, unidade: 'minutes' },
    { campo: 'auditoria_tolerancia_fusao_min', min: 1, max: 120, padrao: 10, unidade: 'minutes' },
    { campo: 'auditoria_embarque_antes_saida_min', min: 1, max: 240, padrao: 30, unidade: 'minutes' },
    { campo: 'auditoria_duracao_max_viagem_min', min: 10, max: 1440, padrao: 240, unidade: 'minutes' },
    { campo: 'auditoria_margem_dia_min', min: 1, max: 720, padrao: 120, unidade: 'minutes' },
    // Vazio = nunca apaga a trilha (monitor/auditoria/persistencia.limpa_trilha_antiga).
    { campo: 'auditoria_dias_retencao_trilha', min: 7, max: 3650, padrao: null, unidade: 'days' },
];

export default {
    components: {
        MerusDataTable,
        CadastroToolbar,
        ConfigItem,
        StatusVeiculosOperacaoMapPreview,
        MultiplaEscolha,
        CRUDStatusTickets,
    },
    data: () => ({
        // Escopo do envio automático de QR Code. Não são colunas de `configuracoes`:
        // vivem em tabelas filhas e são salvas junto no mesmo PUT.
        escopoQrcode: {
            unidades: [],
            clientes: [],
            empresas: [],
            grupos: [],
            notificados: [],
        },
        metodosEnvioQrcode: [],
        colunasDataEnvioQrcode: [],
        user: null,
        token: null,
        selectedSection: 0,

        config: {
            guias_automaticas: null,
            usar_guias: null,
            limite_tempo_parado: null,
            atraso_minimo_viagens_previstas: null,
            limite_adiantamento_viagem_prevista: null,
            limite_tempo_viagem_menor: null,
            limite_tempo_largada: null,
            hora_inicial_dia_operacao: null,
            hora_inicial_dia_financeiro: null,
            distancia_limite_comboio: null,
            tempo_ciclo_comboio: null,
            intervalo_posicoes_comboio: null,
            tempo_fechamento_automatico: null,
            monitor_roleta_obrigatoria: null,
            monitor_odometro_obrigatorio: null,
            ligar_filtros_roleta: null,
            ligar_filtros_odometro: null,
            porcentagem_diferenca_odometro: null,
            porcentagem_diferenca_roleta: null,
            numero_digitos_roleta: null,
            tempo_atualizacao_notificacoes: null,
            tempo_atualizacao_linhas: null,
            tempo_atualizacao_grade: null,
            limite_envio_equipamento: null,
            limite_envio_equipamento_inferior: null,
            limite_delay_equipamento: null,
            limite_delay_equipamento_inferior: null,
            limite_fora_ordem_equipamento: null,
            limite_fora_ordem_equipamento_inferior: null,
            limite_posicoes_invalidas: null,
            limite_posicoes_invalidas_inferior: null,
            limite_envio_validadores_rastreadores: null,
            limite_posicoes_invalidas_validadores_rastreadores: null,
            limite_envio_rastreadores: null,
            limite_posicoes_invalidas_rastreadores: null,
            limite_horas_atualizacao_equipamento: null,
            raio_cerca_padrao: null,
            limite_adiantamento_cerca_padrao: null,
            limite_atraso_cerca_padrao: null,
            raio_ideal_validacao_candidatos: null,
            raio_maximo_validacao_candidatos: null,
            dias_download_precandidatos_pos_finalizacao: null,
            tempo_maximo_permanencia_linha_minutos: null,
            velocidade_media_estimativa_kmh: null,
            max_linhas_retorno_validacao: null,
            raio_ideal_validacao_candidatos_pcd: null,
            raio_maximo_validacao_candidatos_pcd: null,
            prazo_reserva_candidato_horas: 48,
            monitor_avalia_pessoas: 1,
            monitor_aplica_alocacao_pessoas: 1,
            minimo_embarques_abre_viagem: null,
            janela_embarques_abre_viagem_minutos: null,
            envio_qrcode_automatico: 0,
            envio_qrcode_metodo: 0,
            envio_qrcode_coluna_data: 1,
            envio_qrcode_dias_primeiro_envio: 0,
            envio_qrcode_dias_reenvio: null,
            envio_qrcode_minutos_retentativa: 60,
            envio_qrcode_max_tentativas: 3,
            envio_qrcode_finais_semana: 0,
            envio_qrcode_feriados: 0,
            envio_qrcode_sem_linha_grupo: 0,
            // "Todos" por dimensão do escopo: tira a dimensão do filtro da rotina.
            envio_qrcode_todas_unidades: 0,
            envio_qrcode_todos_clientes: 0,
            envio_qrcode_todas_empresas: 0,
            envio_qrcode_todos_grupos: 0,
            permitir_cadastro_passageiros: null,
            space_id_padrao_googlechat: null,
            enviar_msg_direta_googlechat: null,
            lat_default: null,
            lng_default: null,
            raio_centro_unidades: null,
            raio_aglomeracao_rejeitados: 500,
            percentual_similaridade_minima_rotas: null,
            periodo_busca_alertas_minutos: null,
            inicializa_grid_diario: null,
            usa_escalas_padrao: null,
            motorista_cria_viagem: null,
            motorista_inicio_jornada_obrigatorio: 1,
            motorista_permite_abrir_guia_fora_cerca: 0,
            motorista_tipos_cerca_abrir_guia: null,
            motorista_checkout_minutos_apos_checkin: 5,
            anula_viagem_por_passagem_cerca: null,
            minimo_cercas_anula_viagem: null,
            limite_alertas_tela: null,
            tempo_minimo_anula_viagem: null,
            auditoria_guias_por_viagem: null,
            auditoria_desvio_max_associacao_min: null,
            auditoria_tolerancia_fusao_min: null,
            auditoria_tolerancia_pontualidade_min: null,
            auditoria_embarque_antes_saida_min: null,
            auditoria_duracao_max_viagem_min: null,
            auditoria_margem_dia_min: null,
            auditoria_dias_retencao_trilha: null,
            api_geocodificacao_roteirizacao: 'google',
            tempo_carencia_veiculos: null,
            tempo_busca_fixo_parada_segundos: null,
            tempo_busca_por_passageiro_segundos: null,
            tempo_desembarque_fixo_parada_segundos: null,
            tempo_desembarque_por_passageiro_segundos: null,
        },
        exemploEnvio: 50,
        exemploDelay: 50,
        exemploForaOrdem: 50,
        exemploInvalidas: 50,
        periodoHoras: null,
        tiposNotificacoes: [],
        statusVeiculosOperacao: [],
        canais: [],
        colors: [
            "#F44336",
            "#9C27B0",
            "#FF8F00",
            "#FF5722",
            "#263238"
        ],
        headers: [],
        tabelas: [],
        telas: [],
        selectedIdRecurso: null,
        headersSelected: [],
        spaces: [],
        displayedItemsForExportSpaces: null,
        ticketCamposCriacao: [],
        loadingTicketCampos: false,
        ticketCamposDetalhe: [],
        gruposSolucionadores: [],
        loadingTicketCamposDetalhe: false,
        ticketDetailScreens: ['team', 'cliente', 'criados', 'colaborador', 'dispatcher', 'supervisor'],
        recursos: [],
        limitesApiExternas: [],
        loadingLimitesApiExternas: false,
        tiposCerca: [],
        motoristaTiposCercaSelecionados: [],
        tiposEquipamentos: [],
        relManutencaoTiposEquipamentos: {
            validadores: [],
            rastreadores: [],
            validadores_rastreadores_bilhetagem: [],
            dvr: [],
        },
        relManutencaoLimitesPorTipo: [],
    }),
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.applySectionFromRoute();
        this.populaRecursos().then(() => this.initialize());
    },
    computed: {
        /**
         * Dimensão do escopo do envio de QR Code -> coluna de `configuracoes` que guarda
         * o "Todos" dela. Precisa concordar com ESCOPO_TODOS_CONFIG do
         * monitor/envia_qrcode_pessoas.py.
         */
        colunasEscopoQrcodeTodos() {
            return {
                unidades: 'envio_qrcode_todas_unidades',
                clientes: 'envio_qrcode_todos_clientes',
                empresas: 'envio_qrcode_todas_empresas',
                grupos: 'envio_qrcode_todos_grupos',
            };
        },

        configTexts() {
            return {
                usarGuias: {
                    title: this.$t('config.system_parameters.use_guides.title'),
                    subtitle: this.$t('config.system_parameters.use_guides.subtitle'),
                    helpText: ""
                },
                inicializaGridDiario: {
                    title: this.$t('config.system_parameters.initializeGrid.title'),
                    subtitle: this.$t('config.system_parameters.initializeGrid.subtitle'),
                    helpText: ""
                },
                usaEscalasPadrao: {
                    title: this.$t('config.system_parameters.useSchedulesStandard.title'),
                    subtitle: this.$t('config.system_parameters.useSchedulesStandard.subtitle'),
                    helpText: ""
                },
                motoristaCreateTrip: {
                    title: this.$t('config.system_parameters.motoristaCreateTrip.title'),
                    subtitle: this.$t('config.system_parameters.motoristaCreateTrip.subtitle'),
                    helpText: ""
                },
                motoristaInicioJornadaObrigatorio: {
                    title: this.$t('config.system_parameters.motoristaInicioJornadaObrigatorio.title'),
                    subtitle: this.$t('config.system_parameters.motoristaInicioJornadaObrigatorio.subtitle'),
                    helpText: ""
                },
                motoristaCheckoutMinutosAposCheckin: {
                    title: this.$t('config.system_parameters.motoristaCheckoutMinutosAposCheckin.title'),
                    subtitle: this.$t('config.system_parameters.motoristaCheckoutMinutosAposCheckin.subtitle'),
                    helpText: this.$t('config.system_parameters.motoristaCheckoutMinutosAposCheckin.helpText')
                },
                motoristaPermiteAbrirGuiaForaCerca: {
                    title: this.$t('config.system_parameters.motoristaPermiteAbrirGuiaForaCerca.title'),
                    subtitle: this.$t('config.system_parameters.motoristaPermiteAbrirGuiaForaCerca.subtitle'),
                    helpText: this.$t('config.system_parameters.motoristaPermiteAbrirGuiaForaCerca.helpText')
                },
                motoristaTiposCercaAbrirGuia: {
                    title: this.$t('config.system_parameters.motoristaTiposCercaAbrirGuia.title'),
                    subtitle: this.$t('config.system_parameters.motoristaTiposCercaAbrirGuia.subtitle'),
                    helpText: this.$t('config.system_parameters.motoristaTiposCercaAbrirGuia.helpText')
                },
                guiasAutomaticas: {
                    title: this.$t('config.system_parameters.automatic_guides.title'),
                    subtitle: this.$t('config.system_parameters.automatic_guides.subtitle'),
                    helpText: this.$t('config.system_parameters.automatic_guides.helpText')
                },
                cadastroPassageiros: {
                    title: this.$t('config.system_parameters.passenger_registration.title'),
                    subtitle: this.$t('config.system_parameters.passenger_registration.subtitle'),
                    helpText: ""
                },
                periodoBuscaAlertas: {
                    title: this.$t('config.system_parameters.alertSearchPeriod.title'),
                    subtitle: this.$t('config.system_parameters.alertSearchPeriod.subtitle'),
                    helpText: this.$t('config.system_parameters.alertSearchPeriod.helpText')
                },
                latDefault: {
                    title: this.$t('config.system_parameters.lat_default.title'),
                    subtitle: this.$t('config.system_parameters.lat_default.subtitle'),
                    helpText: ""
                },
                lngDefault: {
                    title: this.$t('config.system_parameters.lng_default.title'),
                    subtitle: this.$t('config.system_parameters.lng_default.subtitle'),
                    helpText: ""
                },
                geocodingApiRouting: {
                    title: this.$t('config.system_parameters.geocoding_api_routing.title'),
                    subtitle: this.$t('config.system_parameters.geocoding_api_routing.subtitle'),
                    helpText: this.$t('config.system_parameters.geocoding_api_routing.helpText')
                },
                tempoCarenciaVeiculos: {
                    title: this.$t('config.system_parameters.tempo_carencia_veiculos.title'),
                    subtitle: this.$t('config.system_parameters.tempo_carencia_veiculos.subtitle'),
                    helpText: this.$t('config.system_parameters.tempo_carencia_veiculos.helpText')
                },
                tempoBuscaFixoParada: {
                    title: this.$t('config.system_parameters.tempo_busca_fixo_parada.title'),
                    subtitle: this.$t('config.system_parameters.tempo_busca_fixo_parada.subtitle'),
                    helpText: this.$t('config.system_parameters.tempo_busca_fixo_parada.helpText')
                },
                tempoBuscaPorPassageiro: {
                    title: this.$t('config.system_parameters.tempo_busca_por_passageiro.title'),
                    subtitle: this.$t('config.system_parameters.tempo_busca_por_passageiro.subtitle'),
                    helpText: this.$t('config.system_parameters.tempo_busca_por_passageiro.helpText')
                },
                tempoDesembarqueFixoParada: {
                    title: this.$t('config.system_parameters.tempo_desembarque_fixo_parada.title'),
                    subtitle: this.$t('config.system_parameters.tempo_desembarque_fixo_parada.subtitle'),
                    helpText: this.$t('config.system_parameters.tempo_desembarque_fixo_parada.helpText')
                },
                tempoDesembarquePorPassageiro: {
                    title: this.$t('config.system_parameters.tempo_desembarque_por_passageiro.title'),
                    subtitle: this.$t('config.system_parameters.tempo_desembarque_por_passageiro.subtitle'),
                    helpText: this.$t('config.system_parameters.tempo_desembarque_por_passageiro.helpText')
                },
                externalApiLimits: {
                    title: this.$t('config.system_parameters.external_api_limits.title'),
                    subtitle: this.$t('config.system_parameters.external_api_limits.subtitle'),
                    helpText: this.$t('config.system_parameters.external_api_limits.helpText')
                },
                atrasoMinimo: {
                    title: this.$t('config.system_parameters.min_trip_delay.title'),
                    subtitle: this.$t('config.system_parameters.min_trip_delay.subtitle'),
                    helpText: ""
                },
                atrasoMaximo: {
                    title: this.$t('config.system_parameters.max_trip_delay.title'),
                    subtitle: this.$t('config.system_parameters.max_trip_delay.subtitle'),
                    helpText: ""
                },
                limiteAdiantamento: {
                    title: this.$t('config.system_parameters.early_trip_limit.title'),
                    subtitle: this.$t('config.system_parameters.early_trip_limit.subtitle'),
                    helpText: this.$t('config.system_parameters.early_trip_limit.helpText')
                },
                tempoLimiteLargada: {
                    title: this.$t('config.system_parameters.departure_time_limit.title'),
                    subtitle: this.$t('config.system_parameters.departure_time_limit.subtitle'),
                    helpText: ""
                },
                tempoLimiteFechamentoAutomatico: {
                    title: this.$t('config.system_parameters.auto_close_time.title'),
                    subtitle: this.$t('config.system_parameters.auto_close_time.subtitle'),
                    helpText: ""
                },
                limiteDeTempoParado: {
                    title: this.$t('config.system_parameters.stop_time_limit.title'),
                    subtitle: this.$t('config.system_parameters.stop_time_limit.subtitle'),
                    helpText: this.$t('config.system_parameters.stop_time_limit.helpText')
                },
                distanciaLimiteComboio: {
                    title: this.$t('config.system_parameters.convoy_distance.title'),
                    subtitle: this.$t('config.system_parameters.convoy_distance.subtitle'),
                    helpText: ""
                },
                tempoCicloComboio: {
                    title: this.$t('config.system_parameters.convoy_cycle_time.title'),
                    subtitle: this.$t('config.system_parameters.convoy_cycle_time.subtitle'),
                    helpText: ""
                },
                intervaloPosicoesComboio: {
                    title: this.$t('config.system_parameters.position_interval.title'),
                    subtitle: this.$t('config.system_parameters.position_interval.subtitle'),
                    helpText: ""
                },
                diaOperacional: {
                    title: this.$t('config.system_parameters.operational_day.title'),
                    subtitle: this.$t('config.system_parameters.operational_day.subtitle'),
                    helpText: ""
                },
                diaFinanceiro: {
                    title: this.$t('config.system_parameters.financial_day.title'),
                    subtitle: this.$t('config.system_parameters.financial_day.subtitle'),
                    helpText: ""
                },
                raioCercaPadrao: {
                    title: this.$t('config.system_parameters.default_fence_radius.title'),
                    subtitle: this.$t('config.system_parameters.default_fence_radius.subtitle'),
                    helpText: ""
                },
                limiteAtrasoCercaPadrao: {
                    title: this.$t('config.system_parameters.default_fence_delay_limit.title'),
                    subtitle: this.$t('config.system_parameters.default_fence_delay_limit.subtitle'),
                    helpText: ""
                },
                limiteAdiantamentoCercaPadrao: {
                    title: this.$t('config.system_parameters.default_fence_early_limit.title'),
                    subtitle: this.$t('config.system_parameters.default_fence_early_limit.subtitle'),
                    helpText: ""
                },
                raioIdealValidacaoCandidatos: {
                    title: this.$t('config.system_parameters.candidate_validation_ideal_radius.title'),
                    subtitle: this.$t('config.system_parameters.candidate_validation_ideal_radius.subtitle'),
                    helpText: ""
                },
                diasDownloadPrecandidatos: {
                    title: this.$t('config.system_parameters.dias_download_precandidatos_pos_finalizacao.title'),
                    subtitle: this.$t('config.system_parameters.dias_download_precandidatos_pos_finalizacao.subtitle'),
                    helpText: this.$t('config.system_parameters.dias_download_precandidatos_pos_finalizacao.helpText')
                },
                raioMaximoValidacaoCandidatos: {
                    title: this.$t('config.system_parameters.candidate_validation_max_radius.title'),
                    subtitle: this.$t('config.system_parameters.candidate_validation_max_radius.subtitle'),
                    helpText: ""
                },
                tempoMaximoPermanenciaLinha: {
                    title: this.$t('config.system_parameters.max_line_ride_time.title'),
                    subtitle: this.$t('config.system_parameters.max_line_ride_time.subtitle'),
                    helpText: this.$t('config.system_parameters.max_line_ride_time.helpText')
                },
                maxLinhasRetornoValidacao: {
                    title: this.$t('config.system_parameters.max_lines_validation.title'),
                    subtitle: this.$t('config.system_parameters.max_lines_validation.subtitle'),
                    helpText: this.$t('config.system_parameters.max_lines_validation.helpText')
                },
                velocidadeMediaEstimativa: {
                    title: this.$t('config.system_parameters.ride_time_average_speed.title'),
                    subtitle: this.$t('config.system_parameters.ride_time_average_speed.subtitle'),
                    helpText: this.$t('config.system_parameters.ride_time_average_speed.helpText')
                },
                raioIdealValidacaoCandidatosPcd: {
                    title: this.$t('config.system_parameters.pcd_candidate_validation_ideal_radius.title'),
                    subtitle: this.$t('config.system_parameters.pcd_candidate_validation_ideal_radius.subtitle'),
                    helpText: ""
                },
                raioMaximoValidacaoCandidatosPcd: {
                    title: this.$t('config.system_parameters.pcd_candidate_validation_max_radius.title'),
                    subtitle: this.$t('config.system_parameters.pcd_candidate_validation_max_radius.subtitle'),
                    helpText: ""
                },
                prazoReservaCandidatoHoras: {
                    title: this.$t('config.system_parameters.candidate_reservation_hours.title'),
                    subtitle: this.$t('config.system_parameters.candidate_reservation_hours.subtitle'),
                    helpText: ""
                },
                envioQrcodeAutomatico: {
                    title: this.$t('config.system_parameters.envio_qrcode_automatico.title'),
                    subtitle: this.$t('config.system_parameters.envio_qrcode_automatico.subtitle'),
                    helpText: this.$t('config.system_parameters.envio_qrcode_automatico.helpText')
                },
                envioQrcodeMetodo: {
                    title: this.$t('config.system_parameters.envio_qrcode_metodo.title'),
                    subtitle: this.$t('config.system_parameters.envio_qrcode_metodo.subtitle'),
                    helpText: this.$t('config.system_parameters.envio_qrcode_metodo.helpText')
                },
                envioQrcodeColunaData: {
                    title: this.$t('config.system_parameters.envio_qrcode_coluna_data.title'),
                    subtitle: this.$t('config.system_parameters.envio_qrcode_coluna_data.subtitle'),
                    helpText: this.$t('config.system_parameters.envio_qrcode_coluna_data.helpText')
                },
                envioQrcodeDiasPrimeiroEnvio: {
                    title: this.$t('config.system_parameters.envio_qrcode_dias_primeiro_envio.title'),
                    subtitle: this.$t('config.system_parameters.envio_qrcode_dias_primeiro_envio.subtitle'),
                    helpText: this.$t('config.system_parameters.envio_qrcode_dias_primeiro_envio.helpText')
                },
                envioQrcodeDiasReenvio: {
                    title: this.$t('config.system_parameters.envio_qrcode_dias_reenvio.title'),
                    subtitle: this.$t('config.system_parameters.envio_qrcode_dias_reenvio.subtitle'),
                    helpText: this.$t('config.system_parameters.envio_qrcode_dias_reenvio.helpText')
                },
                envioQrcodeMinutosRetentativa: {
                    title: this.$t('config.system_parameters.envio_qrcode_minutos_retentativa.title'),
                    subtitle: this.$t('config.system_parameters.envio_qrcode_minutos_retentativa.subtitle'),
                    helpText: this.$t('config.system_parameters.envio_qrcode_minutos_retentativa.helpText')
                },
                envioQrcodeMaxTentativas: {
                    title: this.$t('config.system_parameters.envio_qrcode_max_tentativas.title'),
                    subtitle: this.$t('config.system_parameters.envio_qrcode_max_tentativas.subtitle'),
                    helpText: this.$t('config.system_parameters.envio_qrcode_max_tentativas.helpText')
                },
                envioQrcodeFinaisSemana: {
                    title: this.$t('config.system_parameters.envio_qrcode_finais_semana.title'),
                    subtitle: this.$t('config.system_parameters.envio_qrcode_finais_semana.subtitle'),
                    helpText: this.$t('config.system_parameters.envio_qrcode_finais_semana.helpText')
                },
                envioQrcodeFeriados: {
                    title: this.$t('config.system_parameters.envio_qrcode_feriados.title'),
                    subtitle: this.$t('config.system_parameters.envio_qrcode_feriados.subtitle'),
                    helpText: this.$t('config.system_parameters.envio_qrcode_feriados.helpText')
                },
                envioQrcodeSemLinhaGrupo: {
                    title: this.$t('config.system_parameters.envio_qrcode_sem_linha_grupo.title'),
                    subtitle: this.$t('config.system_parameters.envio_qrcode_sem_linha_grupo.subtitle'),
                    helpText: this.$t('config.system_parameters.envio_qrcode_sem_linha_grupo.helpText')
                },
                envioQrcodeUnidades: {
                    title: this.$t('config.system_parameters.envio_qrcode_unidades.title'),
                    subtitle: this.$t('config.system_parameters.envio_qrcode_unidades.subtitle'),
                    helpText: this.$t('config.system_parameters.envio_qrcode_unidades.helpText')
                },
                envioQrcodeClientes: {
                    title: this.$t('config.system_parameters.envio_qrcode_clientes.title'),
                    subtitle: this.$t('config.system_parameters.envio_qrcode_clientes.subtitle'),
                    helpText: this.$t('config.system_parameters.envio_qrcode_clientes.helpText')
                },
                envioQrcodeEmpresas: {
                    title: this.$t('config.system_parameters.envio_qrcode_empresas.title'),
                    subtitle: this.$t('config.system_parameters.envio_qrcode_empresas.subtitle'),
                    helpText: this.$t('config.system_parameters.envio_qrcode_empresas.helpText')
                },
                envioQrcodeGrupos: {
                    title: this.$t('config.system_parameters.envio_qrcode_grupos.title'),
                    subtitle: this.$t('config.system_parameters.envio_qrcode_grupos.subtitle'),
                    helpText: this.$t('config.system_parameters.envio_qrcode_grupos.helpText')
                },
                envioQrcodeNotificados: {
                    title: this.$t('config.system_parameters.envio_qrcode_notificados.title'),
                    subtitle: this.$t('config.system_parameters.envio_qrcode_notificados.subtitle'),
                    helpText: this.$t('config.system_parameters.envio_qrcode_notificados.helpText')
                },
                monitorAvaliaPessoas: {
                    title: this.$t('config.system_parameters.monitor_avalia_pessoas.title'),
                    subtitle: this.$t('config.system_parameters.monitor_avalia_pessoas.subtitle'),
                    helpText: this.$t('config.system_parameters.monitor_avalia_pessoas.helpText')
                },
                monitorAplicaAlocacaoPessoas: {
                    title: this.$t('config.system_parameters.monitor_aplica_alocacao_pessoas.title'),
                    subtitle: this.$t('config.system_parameters.monitor_aplica_alocacao_pessoas.subtitle'),
                    helpText: this.$t('config.system_parameters.monitor_aplica_alocacao_pessoas.helpText')
                },
                minimoEmbarquesAbreViagem: {
                    title: this.$t('config.system_parameters.minimo_embarques_abre_viagem.title'),
                    subtitle: this.$t('config.system_parameters.minimo_embarques_abre_viagem.subtitle'),
                    helpText: this.$t('config.system_parameters.minimo_embarques_abre_viagem.helpText')
                },
                janelaEmbarquesAbreViagem: {
                    title: this.$t('config.system_parameters.janela_embarques_abre_viagem.title'),
                    subtitle: this.$t('config.system_parameters.janela_embarques_abre_viagem.subtitle'),
                    helpText: this.$t('config.system_parameters.janela_embarques_abre_viagem.helpText')
                },
                unitCenterRadius: {
                    title: this.$t('config.system_parameters.unit_center_radius.title'),
                    subtitle: this.$t('config.system_parameters.unit_center_radius.subtitle'),
                    helpText: ""
                },
                raioAglomeracaoRejeitados: {
                    title: this.$t('config.system_parameters.rejected_agglomeration_radius.title'),
                    subtitle: this.$t('config.system_parameters.rejected_agglomeration_radius.subtitle'),
                    helpText: ""
                },
                anulaViagemPorPassagemCerca: {
                    title: this.$t('config.system_parameters.anula_viagem_por_passagem_cerca.title'),
                    subtitle: this.$t('config.system_parameters.anula_viagem_por_passagem_cerca.subtitle'),
                    helpText: ""
                },
                minimoCercasAnulaViagem: {
                    title: this.$t('config.system_parameters.minimo_cercas_anula_viagem.title'),
                    subtitle: this.$t('config.system_parameters.minimo_cercas_anula_viagem.subtitle'),
                    helpText: ""
                },
                tempoMinimoAnulaViagem: {
                    title: this.$t('config.system_parameters.tempo_minimo_anula_viagem.title'),
                    subtitle: this.$t('config.system_parameters.tempo_minimo_anula_viagem.subtitle'),
                    helpText: ""
                },
                auditoriaGuiasPorViagem: {
                    title: this.$t('config.system_parameters.auditoria_guias_por_viagem.title'),
                    subtitle: this.$t('config.system_parameters.auditoria_guias_por_viagem.subtitle'),
                    helpText: this.$t('config.system_parameters.auditoria_guias_por_viagem.helpText')
                },
                roletaObrigatoria: {
                    title: this.$t('config.merus_monitor.mandatory_turnstile.title'),
                    subtitle: this.$t('config.merus_monitor.mandatory_turnstile.subtitle'),
                    helpText: ""
                },
                odometroObrigatorio: {
                    title: this.$t('config.merus_monitor.mandatory_odometer.title'),
                    subtitle: this.$t('config.merus_monitor.mandatory_odometer.subtitle'),
                    helpText: ""
                },
                ligarFiltrosRoleta: {
                    title: this.$t('config.merus_monitor.enable_turnstile_filters.title'),
                    subtitle: this.$t('config.merus_monitor.enable_turnstile_filters.subtitle'),
                    helpText: ""
                },
                diferencaRoleta: {
                    title: this.$t('config.merus_monitor.turnstile_difference.title'),
                    subtitle: this.$t('config.merus_monitor.turnstile_difference.subtitle'),
                    helpText: ""
                },
                digitosRoleta: {
                    title: this.$t('config.merus_monitor.turnstile_digits.title'),
                    subtitle: this.$t('config.merus_monitor.turnstile_digits.subtitle'),
                    helpText: ""
                },
                ligarFiltrosOdometro: {
                    title: this.$t('config.merus_monitor.enable_odometer_filters.title'),
                    subtitle: this.$t('config.merus_monitor.enable_odometer_filters.subtitle'),
                    helpText: ""
                },
                diferencaOdometro: {
                    title: this.$t('config.merus_monitor.odometer_difference.title'),
                    subtitle: this.$t('config.merus_monitor.odometer_difference.subtitle'),
                    helpText: ""
                },
                atualizacaoNotificacoes: {
                    title: this.$t('config.notifications.notification_update.title'),
                    subtitle: this.$t('config.notifications.notification_update.subtitle'),
                    helpText: ""
                },
                atualizacaoLinhas: {
                    title: this.$t('config.notifications.lines_update.title'),
                    subtitle: this.$t('config.notifications.lines_update.subtitle'),
                    helpText: ""
                },
                atualizacaoGrade: {
                    title: this.$t('config.notifications.schedule_update.title'),
                    subtitle: this.$t('config.notifications.schedule_update.subtitle'),
                    helpText: ""
                },
                limiteEnvio: {
                    title: this.$t('config.notifications.send_limit.title'),
                    subtitle: this.$t('config.notifications.send_limit.subtitle'),
                    helpText: ""
                },
                limitePosicoesValidas: {
                    title: this.$t('config.notifications.valid_positions_limit.title'),
                    subtitle: this.$t('config.notifications.valid_positions_limit.subtitle'),
                    helpText: ""
                },
                limiteForaOrdem: {
                    title: this.$t('config.reports.out_of_order_limit.title'),
                    subtitle: this.$t('config.reports.out_of_order_limit.subtitle'),
                    helpText: ""
                },
                limiteDelay: {
                    title: this.$t('config.reports.delay_limit.title'),
                    subtitle: this.$t('config.reports.delay_limit.subtitle'),
                    helpText: ""
                },
                limiteHorasAtualizacaoEquipamento: {
                    title: this.$t('config.reports.equipment_update_hours_limit.title'),
                    subtitle: this.$t('config.reports.equipment_update_hours_limit.subtitle'),
                    helpText: this.$t('config.reports.equipment_update_hours_limit.helpText')
                },
                percentualSimilaridadeMinimaRotas: {
                    title: this.$t('config.system_parameters.percentual_similaridade_minima_rotas.title'),
                    subtitle: this.$t('config.system_parameters.percentual_similaridade_minima_rotas.subtitle'),
                    helpText: ""
                },
                limiteAlertasTela: {
                    title: this.$t('config.system_parameters.alert_limit_on_screen.title'),
                    subtitle: this.$t('config.system_parameters.alert_limit_on_screen.subtitle'),
                    helpText: ""
                },
                limiteLinhasExportacaoCsvLocal: {
                    title: this.$t('config.system_parameters.csv_local_row_limit.title'),
                    subtitle: this.$t('config.system_parameters.csv_local_row_limit.subtitle'),
                    helpText: this.$t('config.system_parameters.csv_local_row_limit.helpText')
                }
            }
        },
        relManutencaoTipoAbas() {
            return [
                {
                    key: 'validadores',
                    label: 'Validadores',
                    subtitle: 'Face-ID e outros validadores de comunicação',
                },
                {
                    key: 'rastreadores',
                    label: 'Rastreadores',
                    subtitle: 'Geotab, QuecLink e outros rastreadores',
                },
                {
                    key: 'validadores_rastreadores_bilhetagem',
                    label: 'Validadores/Rastreadores/Bilhetagem',
                    subtitle: 'Equipamentos que combinam AVL, validador e bilhetagem',
                },
                {
                    key: 'dvr',
                    label: 'DVR',
                    subtitle: 'Equipamentos de vídeo com status Hikvision Mobile',
                },
            ];
        },
        relManutencaoGruposLimites() {
            return [
                { key: 'validadores_rastreadores_bilhetagem', label: 'Equipamentos Validadores/Rastreadores', color: 'indigo' },
                { key: 'rastreadores', label: 'Equipamentos Rastreadores', color: 'teal' },
            ];
        },
        headersConfigTabelas() {
            return [
                { text: this.$t('config.headersConfigTable.header'), value: "id_header", sortable: false, align: " d-none" },
                { text: this.$t('config.headersConfigTable.column'), value: "text", sortable: false },
                { text: this.$t('config.headersConfigTable.exportLabel'), value: "label", sortable: false },
                { text: this.$t('config.headersConfigTable.export'), value: "to_export", sortable: false, align: "center", width: "100px" },
                { text: this.$t('config.headersConfigTable.order'), value: "order", sortable: false, align: "center", width: "120px" }]
        },
        sections() {
            return [
                { key: "system_parameters", icon: "mdi-cog", text: this.$t('config.navigation.sections.system_parameters') },
                { key: "merus_monitor", icon: "mdi-monitor", text: this.$t('config.navigation.sections.merus_monitor') },
                { key: "notifications", icon: "mdi-exclamation-thick", text: this.$t('config.navigation.sections.notifications') },
                { key: "real_time", icon: "mdi-clock-outline", text: this.$t('config.navigation.sections.real_time') },
                { key: "reports", icon: "mdi-file-chart", text: this.$t('config.navigation.sections.reports') },
                { key: "tables", icon: "mdi-table", text: this.$t('config.navigation.sections.tables') },
                { key: "communication", icon: "mdi-email-fast", text: this.$t('config.navigation.sections.communication') },
                { key: "ticket_creation_fields", icon: "mdi-form-select", text: this.$t('config.navigation.sections.ticket_creation_fields') },
                { key: "ticket_status", icon: "mdi-ticket-confirmation", text: this.$t('config.navigation.sections.ticket_status'), show: this.podeVerStatusTickets },
                { key: "ticket_detail_fields", icon: "mdi-eye", text: this.$t('config.navigation.sections.ticket_detail_fields') },
                { key: "vehicle_operation_status", icon: "mdi-bus", text: this.$t('config.navigation.sections.vehicle_operation_status') },
                { key: "business_hours", icon: "mdi-calendar-clock", text: this.$t('config.navigation.sections.business_hours') },
                { key: "trip_audit", icon: "mdi-clipboard-check-multiple-outline", text: this.$t('config.navigation.sections.trip_audit') }];
        },
        /**
         * A seção usa os endpoints da tela StatusTickets, não os de Config: só aparece para
         * quem tem essa tela (mesmo critério do antigo item de menu).
         */
        podeVerStatusTickets() {
            if (this.user?.is_superadmin) return true;
            try {
                const permissoes = JSON.parse(sessionStorage.getItem('permissoes') || '[]');
                return Array.isArray(permissoes) && permissoes.some((p) => p.nome_tela === 'StatusTickets');
            } catch (e) {
                return false;
            }
        },
        isTicketStatusSection() {
            return this.sections[this.selectedSection]?.key === "ticket_status";
        },
        /** Campos numéricos da seção Auditoria de viagens, com o padrão do monitor como dica. */
        parametrosAuditoria() {
            return PARAMETROS_AUDITORIA.map((p) => ({
                ...p,
                titulo: this.$t(`config.trip_audit.${p.campo}.title`),
                subtitulo: this.$t(`config.trip_audit.${p.campo}.subtitle`),
                unidade: this.$t(`config.trip_audit.units.${p.unidade}`),
                dica: p.padrao != null
                    ? this.$t('config.trip_audit.defaultValue', { valor: p.padrao })
                    : this.$t('config.trip_audit.noLimit'),
            }));
        },
        /** Sufixos das colunas hora_util_inicio_* / hora_util_fim_* de configuracoes. */
        diasHorasUteis() {
            return [
                { key: 'segunda', text: this.$t('turnosPassageiros.headers.validMonday') },
                { key: 'terca', text: this.$t('turnosPassageiros.headers.validTuesday') },
                { key: 'quarta', text: this.$t('turnosPassageiros.headers.validWednesday') },
                { key: 'quinta', text: this.$t('turnosPassageiros.headers.validThursday') },
                { key: 'sexta', text: this.$t('turnosPassageiros.headers.validFriday') },
                { key: 'sabado', text: this.$t('turnosPassageiros.headers.validSaturday') },
                { key: 'domingo', text: this.$t('turnosPassageiros.headers.validSunday') }];
        },
        previewStatusMapKey() {
            return this.statusVeiculosOperacao
                .map((s) => `${s.cod_status}:${s.cor}:${s.visivel}:${s.ativo}`)
                .join('|');
        },
        headersSpaces() {
            return [
                { text: this.$t('config.data_table.id_space'), value: "id_space_merus", align: " d-none" },
                { text: this.$t('config.data_table.space_id'), value: "spaceId", sortable: true, filtrable: true },
                { text: this.$t('config.data_table.description'), value: "displayName", sortable: true, filtrable: true },
                { text: this.$t('config.data_table.last_update'), value: "lastActiveTime", sortable: true, filtrable: true },
                { text: this.$t('config.data_table.space_uri'), value: "spaceUri" }];
        },
        defaultSort() {
            return [
                { value: 'spaceId', options: { text: this.$t('routs.increasing'), value: 1 } }];
        },
        title() {
            return this.sections[this.selectedSection].text;
        },
        headersConfigTabelasWithProperties() {
            return this.headersConfigTabelas.map(header => ({
                ...header,
                filtrable: true,
                sortable: true
            }));
        },
        tabelasDoRecursoSelecionado() {
            if (!this.selectedIdRecurso) {
                return [];
            }
            const idRecurso = Number(this.selectedIdRecurso);
            return this.tabelas.filter((t) => Number(t.id_recurso) === idRecurso);
        },
        telasComTabela() {
            const idsComTabela = new Set(
                this.tabelas
                    .filter((t) => t.id_recurso != null && t.id_recurso !== '')
                    .map((t) => Number(t.id_recurso))
            );
            return this.telas
                .filter((t) => idsComTabela.has(Number(t.id_recurso)))
                .slice()
                .sort((a, b) => this.getTelaLabel(a).localeCompare(this.getTelaLabel(b)));
        },
        ticketCamposCriacaoCriados() {
            return (this.ticketCamposCriacao || []).filter((row) => row.tela === 'criados');
        },
        ticketCamposCriacaoCliente() {
            return (this.ticketCamposCriacao || []).filter((row) => row.tela === 'cliente');
        },
        ticketCamposDetalheByScreen() {
            return (screen) => (this.ticketCamposDetalhe || []).filter((row) => row.tela === screen);
        },
        campoOptions() {
            return [
                { value: 'cliente', text: this.$t('config.ticketCreationFields.campo_cliente') },
                { value: 'id_local_empresa', text: this.$t('config.ticketCreationFields.campo_id_local_empresa') },
                { value: 'nome_usuario_solicitante', text: this.$t('config.ticketCreationFields.campo_nome_usuario_solicitante') },
                { value: 'titulo', text: this.$t('config.ticketCreationFields.campo_titulo') },
                { value: 'id_familia_atendimento', text: this.$t('config.ticketCreationFields.campo_id_familia_atendimento') },
                { value: 'id_tipo_solicitacao', text: this.$t('config.ticketCreationFields.campo_id_tipo_solicitacao') },
                { value: 'id_tipo_ticket', text: this.$t('config.ticketCreationFields.campo_id_tipo_ticket') },
                { value: 'id_tipo_atendimento', text: this.$t('config.ticketCreationFields.campo_id_tipo_atendimento') },
                { value: 'id_servico', text: this.$t('config.ticketCreationFields.campo_id_servico') },
                { value: 'id_equipe', text: this.$t('config.ticketCreationFields.campo_id_equipe') },
                { value: 'dataHoras', text: this.$t('config.ticketCreationFields.campo_dataHoras') },
                { value: 'id_usuario_atribuido', text: this.$t('config.ticketCreationFields.campo_id_usuario_atribuido') },
                { value: 'id_usuarios_visualizadores', text: this.$t('config.ticketCreationFields.campo_id_usuarios_visualizadores') },
                { value: 'corpo', text: this.$t('config.ticketCreationFields.campo_corpo') }
            ];
        },
        campoDetalheOptions() {
            return [
                { value: 'empresa', text: this.$t('config.ticketDetailFields.campo_empresa') },
                { value: 'dt_inclusao', text: this.$t('config.ticketDetailFields.campo_dt_inclusao') },
                { value: 'dt_prevista_fim', text: this.$t('config.ticketDetailFields.campo_dt_prevista_fim') },
                { value: 'dt_finalizacao', text: this.$t('config.ticketDetailFields.campo_dt_finalizacao') },
                { value: 'nome_usuario_inclusao', text: this.$t('config.ticketDetailFields.campo_nome_usuario_inclusao') },
                { value: 'tipo_ticket', text: this.$t('config.ticketDetailFields.campo_tipo_ticket') },
                { value: 'tipo_solicitacao', text: this.$t('config.ticketDetailFields.campo_tipo_solicitacao') },
                { value: 'familia_atendimento', text: this.$t('config.ticketDetailFields.campo_familia_atendimento') },
                { value: 'tipo_atendimento', text: this.$t('config.ticketDetailFields.campo_tipo_atendimento') },
                { value: 'servico', text: this.$t('config.ticketDetailFields.campo_servico') },
                { value: 'assigned_user', text: this.$t('config.ticketDetailFields.campo_assigned_user') },
                { value: 'titulo', text: this.$t('config.ticketDetailFields.campo_titulo') },
                { value: 'vehicle', text: this.$t('config.ticketDetailFields.campo_vehicle') },
                { value: 'equipment', text: this.$t('config.ticketDetailFields.campo_equipment') },
                { value: 'status', text: this.$t('config.ticketDetailFields.campo_status') },
                { value: 'status_atribuido', text: this.$t('config.ticketDetailFields.campo_status_atribuido') },
                { value: 'status_dispatcher', text: this.$t('config.ticketDetailFields.campo_status_dispatcher') },
                { value: 'schedule', text: this.$t('config.ticketDetailFields.campo_schedule') },
                { value: 'corpo', text: this.$t('config.ticketDetailFields.campo_corpo') },
                { value: 'endereco', text: this.$t('config.ticketDetailFields.campo_endereco') },
                { value: 'checklist', text: this.$t('config.ticketDetailFields.campo_checklist') },
                { value: 'selection_tree', text: this.$t('config.ticketDetailFields.campo_selection_tree') },
                { value: 'status_change', text: this.$t('config.ticketDetailFields.campo_status_change') },
                { value: 'status_atribuido_change', text: this.$t('config.ticketDetailFields.campo_status_atribuido_change') },
                { value: 'status_dispatcher_change', text: this.$t('config.ticketDetailFields.campo_status_dispatcher_change') },
                { value: 'team', text: this.$t('config.ticketDetailFields.campo_team') },
                { value: 'user_assignment', text: this.$t('config.ticketDetailFields.campo_user_assignment') },
                { value: 'schedule_edit', text: this.$t('config.ticketDetailFields.campo_schedule_edit') },
                { value: 'expected_finalization_edit', text: this.$t('config.ticketDetailFields.campo_expected_finalization_edit') },
                { value: 'vehicle_equipment_edit', text: this.$t('config.ticketDetailFields.campo_vehicle_equipment_edit') },
                { value: 'closing_observations', text: this.$t('config.ticketDetailFields.campo_closing_observations') },
                { value: 'checklist_section', text: this.$t('config.ticketDetailFields.campo_checklist_section') }];
        },
        canManageLimitesApiExternas() {
            return this.user?.is_superadmin === 1
                || this.recursos.some((r) => r.rota === '/api/v1.0/updatelimitesapiexternas');
        },
        limitesApiExternasByOperador() {
            const groups = {};
            for (const row of this.limitesApiExternas || []) {
                const operador = row.operador_api_externa || '';
                if (!groups[operador]) {
                    groups[operador] = [];
                }
                groups[operador].push(row);
            }
            return Object.keys(groups).sort().map((operador) => ({
                operador,
                servicos: groups[operador]
            }));
        }
    },
    methods: {
        async populaRecursos() {
            if (this.user?.is_superadmin === 1) {
                return;
            }
            try {
                const response = await apiController.request(apiController.endpoints.getRecursosusuario, { params: { id: this.user.id_usuario }, silent: true });
                this.recursos = response.data || [];
            } catch (e) {
                EventBus.$emit('show-error', { error: e });
            }
        },
        getCampoLabel(campo) {
            const o = (this.campoOptions || []).find((c) => c.value === campo);
            return o ? o.text : campo;
        },
        getCampoDetalheLabel(campo) {
            const o = (this.campoDetalheOptions || []).find((c) => c.value === campo);
            return o ? o.text : campo;
        },
        normalizeHeaderI18nKey(raw) {
            if (typeof raw !== 'string') {
                return raw;
            }
            const duplicate = /^config\.headersconfigtable\.config\.headersconfigtable\./i;
            if (duplicate.test(raw)) {
                return 'config.headersConfigTable.' + raw.split('.').pop();
            }
            return raw;
        },
        translateHeaderField(raw, translationKey = null) {
            const value = this.normalizeHeaderI18nKey(raw);
            if (translationKey) {
                return translateDbField(translationKey, value);
            }
            if (typeof value === 'string' && value.includes('.')) {
                const translated = this.$t(value);
                if (translated !== value) {
                    return translated;
                }
            }
            const key = 'config.headersConfigTable.' + String(value).toLowerCase().replace(/ /g, '_');
            const translatedText = this.$t(key);
            return translatedText !== key ? translatedText : value;
        },
        resolveHeaderLabel(header) {
            return this.translateHeaderField(header.text, header.translation_key);
        },
        ...mapMutations('config', ['setConfig', 'setTicketCamposCriacao', 'setTicketCamposDetalhe']),
        sectionIndexByKey(key) {
            const idx = this.sections.findIndex((s) => s.key === key);
            return idx >= 0 ? idx : 0;
        },
        applySectionFromRoute() {
            const key = this.$route?.query?.section;
            if (!key) return;
            const idx = this.sectionIndexByKey(key);
            if (this.sections[idx]?.key === key && this.sections[idx].show !== false) {
                this.selectedSection = idx;
            }
        },
        initialize() {
            this.getConfig();
            this.populaTiposCerca();
            //this.populaSpaces();
            this.getHeaders();
            this.populaTelas();
            this.getTabelas();
            this.populaCanais();
            this.populaTiposNotificacoes();
            this.populaTiposEquipamentos();
            this.getRelManutencaoTiposEquipamentos();
            this.populaStatusVeiculosOperacao();
            this.getTicketCamposCriacao();
            this.getTicketCamposDetalhe();
            this.getGruposSolucionadores();
            if (this.canManageLimitesApiExternas) {
                this.getLimitesApiExternas();
            }
        },
        async getGruposSolucionadores() {
            try {
                const response = await apiController.request(apiController.endpoints.getallEquipes, { silent: true });
                const lista = Array.isArray(response.data) ? response.data : [];
                this.gruposSolucionadores = lista
                    .filter((e) => Number(e.ativo) === 1)
                    .map((e) => ({ ...e, email_gravado: e.email_encaminhamento || '' }));
            } catch (e) {
                this.gruposSolucionadores = [];
            }
        },
        emailsGrupoRule(valor) {
            const emails = String(valor || '').split(',').map((e) => e.trim()).filter(Boolean);
            return emails.every((e) => /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/.test(e)) || this.$t('ticketSuporteFluxo.emailInvalido');
        },
        async getLimitesApiExternas() {
            this.loadingLimitesApiExternas = true;
            try {
                const response = await apiController.request(apiController.endpoints.getallLimitesapiexternas, { silent: true });
                const list = Array.isArray(response.data) ? response.data : [];
                list.forEach((row) => {
                    row.limite_chamadas = Number(row.limite_chamadas) || 0;
                    row.dia_refresh = row.dia_refresh != null && row.dia_refresh !== ''
                        ? Number(row.dia_refresh)
                        : (() => {
                            const match = String(row.will_refresh_at || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
                            return match ? parseInt(match[3], 10) : 1;
                        })();
                });
                this.limitesApiExternas = list;
            } catch (e) {
                console.log(e);
                EventBus.$emit('show-error', { error: e });
            } finally {
                this.loadingLimitesApiExternas = false;
            }
        },
        async getTicketCamposCriacao() {
            this.loadingTicketCampos = true;
            try {
                const response = await apiController.request(apiController.endpoints.getTicketCamposCriacao, { silent: true });
                const list = Array.isArray(response.data) ? response.data : [];
                list.forEach(row => {
                    if (row.ativo !== undefined && row.ativo !== null) row.ativo = Number(row.ativo) ? 1 : 0;
                });
                this.ticketCamposCriacao = list;
                this.setTicketCamposCriacao(list);
            } catch (e) {
                console.log(e);
                EventBus.$emit('show-error', { error: e });
            } finally {
                this.loadingTicketCampos = false;
            }
        },
        async getTicketCamposDetalhe() {
            this.loadingTicketCamposDetalhe = true;
            try {
                const response = await apiController.request(apiController.endpoints.getTicketCamposDetalhe, { silent: true });
                const list = Array.isArray(response.data) ? response.data : [];
                list.forEach(row => {
                    if (row.ativo !== undefined && row.ativo !== null) row.ativo = Number(row.ativo) ? 1 : 0;
                });
                this.ticketCamposDetalhe = list;
                this.setTicketCamposDetalhe(list);
            } catch (e) {
                console.log(e);
                EventBus.$emit('show-error', { error: e });
            } finally {
                this.loadingTicketCamposDetalhe = false;
            }
        },
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: (response) => {
                    this.config = response.data[0];
                    const provider = String(this.config.api_geocodificacao_roteirizacao || '').trim().toLowerCase();
                    this.config.api_geocodificacao_roteirizacao = provider === 'here' ? 'here' : 'google';
                    this.config.monitor_avalia_pessoas = this.config.monitor_avalia_pessoas == null
                        ? 1
                        : (Number(this.config.monitor_avalia_pessoas) ? 1 : 0);
                    this.config.monitor_aplica_alocacao_pessoas = this.config.monitor_aplica_alocacao_pessoas == null
                        ? 1
                        : (Number(this.config.monitor_aplica_alocacao_pessoas) ? 1 : 0);
                    this.syncMotoristaTiposCercaSelecionados();
                    // getallconfig devolve o escopo e as opções junto com a linha, para
                    // a tela não precisar de uma segunda chamada.
                    Object.values(this.colunasEscopoQrcodeTodos).forEach((coluna) => {
                        this.$set(this.config, coluna, Number(this.config[coluna]) ? 1 : 0);
                    });
                    const escopo = this.config.escopo_envio_qrcode || {};
                    this.escopoQrcode = {
                        unidades: escopo.unidades || [],
                        clientes: escopo.clientes || [],
                        empresas: escopo.empresas || [],
                        grupos: escopo.grupos || [],
                        notificados: escopo.notificados || [],
                    };
                    this.metodosEnvioQrcode = escopo.metodos || this.metodosEnvioQrcode;
                    this.colunasDataEnvioQrcode = escopo.colunas_data || this.colunasDataEnvioQrcode;
                    this.syncEscopoQrcodeSelecionados();
                    this.setConfig(this.config);
                    this.sincronizarLimitesRelManutencao();
                    // Sincroniza periodoHoras quando carrega as configurações
                    if (this.config.periodo_busca_alertas_minutos) {
                        this.periodoHoras = Math.round(this.config.periodo_busca_alertas_minutos / 60 * 100) / 100;
                    }
                },
                onError: (e) => {
                    console.log("ERRO AXIOS");
                    console.log(e);
                },
            });
        },
        populaTiposCerca() {
            apiController.request(apiController.endpoints.getTiposcerca, {
                onSuccess: (response) => {
                    const list = Array.isArray(response.data) ? response.data : [];
                    this.tiposCerca = list.map((t) => ({
                        ...t,
                        descricaoLabel: translateDbField(t.translation_key, t.descricao_tipo_cerca),
                    }));
                    this.syncMotoristaTiposCercaSelecionados();
                },
                onError: (e) => {
                    console.log("ERRO AXIOS");
                    console.log(e);
                },
            });
        },
        populaTiposEquipamentos() {
            apiController.request(apiController.endpoints.getallTiposequipamentos, {
                onSuccess: (response) => {
                    this.tiposEquipamentos = (response.data || []).filter((tipo) => Number(tipo.ativo) !== 0);
                },
                onError: (e) => {
                    console.log("ERRO AXIOS");
                    console.log(e);
                },
            });
        },
        getRelManutencaoTiposEquipamentos() {
            apiController.request(apiController.endpoints.getRelmanutencaotiposequipamentos, {
                onSuccess: (response) => {
                    const data = response.data || {};
                    this.relManutencaoTiposEquipamentos = {
                        ...this.relManutencaoTiposEquipamentos,
                        ...data,
                    };
                    this.relManutencaoLimitesPorTipo = Array.isArray(data.limites_por_tipo)
                        ? data.limites_por_tipo.map((limite) => ({ ...limite }))
                        : [];
                    this.sincronizarLimitesRelManutencao();
                },
                onError: (e) => {
                    console.log("ERRO AXIOS");
                    console.log(e);
                },
            });
        },
        validarLimitePercentual(value) {
            const numero = Number(value);
            return (value !== null && value !== '' && Number.isFinite(numero) && numero >= 0 && numero <= 100)
                || 'Informe um percentual entre 0 e 100.';
        },
        validateLimitesRelManutencao() {
            this.sincronizarLimitesRelManutencao();
            const limiteInvalido = this.relManutencaoLimitesPorTipo.find((limite) =>
                this.validarLimitePercentual(limite.limite_envio) !== true
                || this.validarLimitePercentual(limite.limite_posicoes_validas) !== true
                || this.validarLimitePercentual(limite.limite_fora_ordem) !== true
                || this.validarLimitePercentual(limite.limite_delay) !== true
            );
            if (limiteInvalido) {
                EventBus.$emit('show-alert', {
                    mensagem: 'Informe todos os limites percentuais entre 0 e 100 para todos os subtipos.',
                    tipo: 'error',
                });
                return false;
            }
            this.relManutencaoLimitesPorTipo.forEach((limite) => {
                limite.limite_envio = Number(limite.limite_envio);
                limite.limite_posicoes_validas = Number(limite.limite_posicoes_validas);
                limite.limite_fora_ordem = Number(limite.limite_fora_ordem);
                limite.limite_delay = Number(limite.limite_delay);
            });
            return true;
        },
        /** Vazio = dia não útil. Preenchido = HH:MM válido. */
        horarioUtilRule(v) {
            if (v === null || v === undefined || v === '') return true;
            return /^([01][0-9]|2[0-3]):[0-5][0-9]$/.test(v) || this.$t('datetime.invalidTime');
        },
        /** Início e fim vêm juntos, com o início antes do fim. */
        horarioUtilFimRule(dia) {
            return () => {
                const inicio = this.config['hora_util_inicio_' + dia] || null;
                const fim = this.config['hora_util_fim_' + dia] || null;
                if (inicio === null && fim === null) return true;
                if (inicio === null || fim === null) return this.$t('config.businessHours.bothRequired');
                return inicio < fim || this.$t('config.businessHours.startBeforeEnd');
            };
        },
        isDiaUtil(dia) {
            return !!this.config['hora_util_inicio_' + dia] && !!this.config['hora_util_fim_' + dia];
        },
        regraParametroAuditoria(p) {
            return (v) => {
                if (v === null || v === undefined || v === '') return true;
                const n = Number(v);
                return (Number.isInteger(n) && n >= p.min && n <= p.max)
                    || this.$t('config.trip_audit.invalid', { min: p.min, max: p.max });
            };
        },
        validateAuditoria() {
            const invalido = this.parametrosAuditoria.find((p) => this.regraParametroAuditoria(p)(this.config[p.campo]) !== true);
            if (invalido) {
                this.selectedSection = this.sectionIndexByKey("trip_audit");
                EventBus.$emit('show-alert', {
                    mensagem: `${invalido.titulo}: ${this.$t('config.trip_audit.invalid', { min: invalido.min, max: invalido.max })}`,
                    tipo: 'error',
                });
                return false;
            }
            return true;
        },
        validateHorasUteis() {
            const diaInvalido = this.diasHorasUteis.find((dia) =>
                this.horarioUtilRule(this.config['hora_util_inicio_' + dia.key]) !== true
                || this.horarioUtilRule(this.config['hora_util_fim_' + dia.key]) !== true
                || this.horarioUtilFimRule(dia.key)() !== true
            );
            if (diaInvalido) {
                this.selectedSection = this.sectionIndexByKey("business_hours");
                EventBus.$emit('show-alert', {
                    mensagem: this.$t('config.businessHours.invalid', { dia: diaInvalido.text }),
                    tipo: 'error',
                });
                return false;
            }
            return true;
        },
        fallbackLimiteRelManutencao(tipoAba, campo) {
            if (campo === 'limite_fora_ordem') {
                return this.config && this.config.limite_fora_ordem_equipamento != null
                    ? Number(this.config.limite_fora_ordem_equipamento) : null;
            }
            if (campo === 'limite_delay') {
                return this.config && this.config.limite_delay_equipamento != null
                    ? Number(this.config.limite_delay_equipamento) : null;
            }
            const porGrupo = tipoAba === 'rastreadores'
                ? (campo === 'limite_envio' ? 'limite_envio_rastreadores' : 'limite_posicoes_invalidas_rastreadores')
                : (campo === 'limite_envio' ? 'limite_envio_validadores_rastreadores' : 'limite_posicoes_invalidas_validadores_rastreadores');
            const global = campo === 'limite_envio' ? 'limite_envio_equipamento' : 'limite_posicoes_invalidas';
            return this.config && this.config[porGrupo] != null ? Number(this.config[porGrupo])
                : (this.config && this.config[global] != null ? Number(this.config[global]) : null);
        },
        sincronizarLimitesRelManutencao() {
            const grupos = this.relManutencaoGruposLimites.map((grupo) => grupo.key);
            const existentes = this.relManutencaoLimitesPorTipo.reduce((acc, limite) => {
                acc[`${limite.tipo_aba}:${Number(limite.id_tipo_equipamento)}`] = limite;
                return acc;
            }, {});
            const sincronizados = [];
            grupos.forEach((tipoAba) => {
                (this.relManutencaoTiposEquipamentos[tipoAba] || []).forEach((id) => {
                    const idTipoEquipamento = Number(id);
                    const chave = `${tipoAba}:${idTipoEquipamento}`;
                    const limite = existentes[chave] || {
                        tipo_aba: tipoAba,
                        id_tipo_equipamento: idTipoEquipamento,
                        limite_envio: null,
                        limite_posicoes_validas: null,
                        limite_fora_ordem: null,
                        limite_delay: null,
                    };
                    if (limite.limite_envio == null) {
                        limite.limite_envio = this.fallbackLimiteRelManutencao(tipoAba, 'limite_envio');
                    }
                    if (limite.limite_posicoes_validas == null) {
                        limite.limite_posicoes_validas = this.fallbackLimiteRelManutencao(tipoAba, 'limite_posicoes_validas');
                    }
                    if (limite.limite_fora_ordem == null) {
                        limite.limite_fora_ordem = this.fallbackLimiteRelManutencao(tipoAba, 'limite_fora_ordem');
                    }
                    if (limite.limite_delay == null) {
                        limite.limite_delay = this.fallbackLimiteRelManutencao(tipoAba, 'limite_delay');
                    }
                    sincronizados.push(limite);
                });
            });
            this.relManutencaoLimitesPorTipo = sincronizados;
        },
        limitesRelManutencaoGrupo(tipoAba) {
            return this.relManutencaoLimitesPorTipo.filter((limite) => limite.tipo_aba === tipoAba);
        },
        nomeTipoEquipamento(id) {
            const tipo = this.tiposEquipamentos.find((item) => Number(item.id_tipo_equipamento) === Number(id));
            return tipo ? tipo.nome_tipo_equipamento : 'Tipo de equipamento';
        },
        relManutencaoTiposResumo(abaKey) {
            const ids = (this.relManutencaoTiposEquipamentos[abaKey] || []).map(Number);
            if (!ids.length) {
                return 'Nenhum tipo configurado na seção "Abas do relatório de manutenção".';
            }
            const labels = ids.map((id) => {
                const tipo = this.tiposEquipamentos.find((t) => Number(t.id_tipo_equipamento) === id);
                return tipo ? `${tipo.nome_tipo_equipamento} (${id})` : `ID ${id}`;
            });
            return labels.join(', ');
        },
        parseTiposCercaConfig(val) {
            if (Array.isArray(val)) {
                return val.map(Number).filter(Number.isFinite);
            }
            if (val == null || val === '') {
                return (this.tiposCerca || []).map((t) => t.id_tipo_cerca);
            }
            return String(val).split(',').map((s) => Number(String(s).trim())).filter(Number.isFinite);
        },
        serializeTiposCercaConfig(ids) {
            const allIds = (this.tiposCerca || []).map((t) => t.id_tipo_cerca);
            if (!Array.isArray(ids) || !ids.length) {
                return allIds.length ? allIds.join(',') : null;
            }
            const normalized = ids.map(Number).filter(Number.isFinite);
            if (!normalized.length) return allIds.length ? allIds.join(',') : null;
            if (allIds.length && normalized.length >= allIds.length
                && allIds.every((id) => normalized.some((n) => String(n) === String(id)))) {
                return allIds.join(',');
            }
            return normalized.join(',');
        },
        /**
         * Marca/desmarca o "Todos" de uma dimensão do escopo. Com ele ligado a rotina
         * ignora a dimensão inteira, e por isso a lista de ids fica vazia: guardar as
         * duas coisas faria a tela mostrar uma seleção que não filtra nada.
         */
        setEscopoQrcodeTodos(chave, valor) {
            const coluna = this.colunasEscopoQrcodeTodos[chave];
            if (!coluna) return;
            const novoValor = valor ? 1 : 0;
            if (this.config[coluna] === novoValor) return;
            this.$set(this.config, coluna, novoValor);
            if (novoValor) {
                this.escopoQrcode = { ...this.escopoQrcode, [chave]: [] };
            }
        },
        /**
         * Empurra o escopo salvo para dentro dos selects. `MultiplaEscolha` não tem prop
         * `selectedItems` — o `.sync` só recebe o emit — então sem isto os selects abrem
         * vazios e o primeiro save apagaria a seleção que já estava gravada.
         */
        syncEscopoQrcodeSelecionados() {
            const refs = {
                unidades: 'envioQrcodeUnidadesSelect',
                clientes: 'envioQrcodeClientesSelect',
                empresas: 'envioQrcodeEmpresasSelect',
                grupos: 'envioQrcodeGruposSelect',
                notificados: 'envioQrcodeNotificadosSelect',
            };
            this.$nextTick(() => {
                Object.keys(refs).forEach((chave) => {
                    // `setSelectedItems` desliga o modo "Todos" do componente; chamá-lo
                    // numa dimensão que está em "Todos" apagaria o estado recém-carregado.
                    const coluna = this.colunasEscopoQrcodeTodos[chave];
                    if (coluna && this.config[coluna]) {
                        return;
                    }
                    const alvo = this.$refs[refs[chave]];
                    const componente = Array.isArray(alvo) ? alvo[0] : alvo;
                    if (componente && typeof componente.setSelectedItems === 'function') {
                        componente.setSelectedItems(this.escopoQrcode[chave] || []);
                    }
                });
            });
        },
        syncMotoristaTiposCercaSelecionados() {
            const parsed = this.parseTiposCercaConfig(
                this.config && this.config.motorista_tipos_cerca_abrir_guia,
            );
            this.motoristaTiposCercaSelecionados = parsed;
            if (this.$refs.motoristaTiposCercaSelect) {
                this.$refs.motoristaTiposCercaSelect.setSelectedItems(parsed);
            }
        },
        populaSpaces() {
            this.loading = true;
            apiController.request(apiController.endpoints.googleListspaces, {
                onSuccess: (response) => {
                    this.loading = false;
                    if (!response.data.erro) {
                        this.spaces = response.data.spaces;
                    }
                },
                onError: (e) => {
                    this.loading = false;
                    console.log("ERRO AXIOS");
                    console.log(e);
                },
            });
        },
        getHeaders() {
            apiController.request(apiController.endpoints.getallHeaderstodisplay, {
                onSuccess: (response) => {
                    this.headers = response.data;
                    for (let header of this.headers) {
                        header.originalText = header.text;
                        const translatedText = this.resolveHeaderLabel(header);
                        if (header.to_export == null || header.to_export === undefined) {
                            header.to_export = 1;
                        } else {
                            header.to_export = Number(header.to_export);
                        }
                        const rawLabel = header.label && String(header.label).trim();
                        header.label = rawLabel
                            ? this.translateHeaderField(header.label)
                            : translatedText;
                        header.text = translatedText;
                    }
                    const toSelect = this.headers.filter((h) => Number(h.to_show) === 1);
                    this.headersSelected = toSelect;
                    this.$nextTick(() => {
                        this.headersSelected = [...toSelect];
                    });
                },
                onError: (e) => {
                    console.log("ERRO AXIOS");
                    console.log(e);
                },
            });
        },
        getTabelas() {
            apiController.request(apiController.endpoints.getallTabelas, {
                onSuccess: (response) => {
                    let aux = [];
                    for (let tabela of response.data) {
                        aux.push({
                            ...tabela,
                            descricao: this.$t('config.tables.table_names.' + tabela.cod_tabela.toLowerCase())
                        });
                    }
                    this.tabelas = aux;
                    this.vincularTabelasRecursos();
                },
                onError: (e) => {
                    console.log("ERRO AXIOS");
                    console.log(e);
                },
            });
        },
        populaTelas() {
            apiController.request(apiController.endpoints.getallRecursos, {
                onSuccess: (response) => {
                    this.telas = (response.data || []).filter((t) => Number(t.id_tipo_recurso) === 2);
                    this.vincularTabelasRecursos();
                },
                onError: (e) => {
                    console.log("ERRO AXIOS");
                    console.log(e);
                },
            });
        },
        vincularTabelasRecursos() {
            if (!this.telas.length || !this.tabelas.length) {
                return;
            }
            const rotaPorCodTabela = {
                GRIDVIAGENS: '/quadroviagens',
                RELPREVREAL: '/relprevistorealizado',
                VIAGENSMERUS: '/conciliacaoviagens',
                VIAGENSOPERADORA: '/conciliacaoviagens',
                PASSAGEIROS: '/pessoas',
                USUARIOSPASSAGEIROS: '/relusuariospassageiros',
            };
            for (const tabela of this.tabelas) {
                if (tabela.id_recurso) {
                    continue;
                }
                const rota = rotaPorCodTabela[tabela.cod_tabela];
                if (!rota) {
                    continue;
                }
                const tela = this.telas.find((t) => t.rota === rota);
                if (tela) {
                    tabela.id_recurso = tela.id_recurso;
                }
            }
        },
        getTelaLabel(tela) {
            return tela.nome || tela.cod_recurso || String(tela.id_recurso);
        },
        populaTiposNotificacoes() {
            apiController.request(apiController.endpoints.getallTiposnotificacoes, {
                onSuccess: (response) => {
                    let aux = [];
                    for (let tipo of response.data) {
                        aux.push({
                            ...tipo,
                            descricao_tipo_notificacao: translateDbField(tipo.translation_key, tipo.descricao_tipo_notificacao)
                        });
                    }
                    this.tiposNotificacoes = aux;
                },
                onError: (e) => {
                    console.log("ERRO AXIOS");
                    console.log(e);
                },
            });
        },
        populaStatusVeiculosOperacao() {
            apiController.request(apiController.endpoints.getallStatusveiculosoperacao, {
                onSuccess: (response) => {
                    const aux = [];
                    for (const status of response.data) {
                        aux.push({
                            ...status,
                            visivel: Number(status.visivel) ? 1 : 0,
                            ativo: Number(status.ativo !== undefined && status.ativo !== null ? status.ativo : 1) ? 1 : 0,
                            descricao: translateDbField(status.translation_key, status.descricao),
                        });
                    }
                    this.statusVeiculosOperacao = aux;
                },
                onError: (e) => {
                    console.log("ERRO AXIOS");
                    console.log(e);
                },
            });
        },
        populaCanais() {
            apiController.request(apiController.endpoints.getallCanaiscomunicacao, {
                onSuccess: (response) => {
                    this.canais = response.data;
                },
                onError: (e) => {
                    console.log("ERRO AXIOS");
                    console.log(e);
                },
            });
        },
        cancel() {
            this.initialize();
        },
        async save() {
            this.config.motorista_tipos_cerca_abrir_guia = this.serializeTiposCercaConfig(
                this.motoristaTiposCercaSelecionados,
            );
            if (!this.validateLimitesRelManutencao()) {
                return;
            }
            if (!this.validateHorasUteis()) {
                return;
            }
            if (!this.validateAuditoria()) {
                return;
            }
            const relManutencaoTiposPayload = {
                ...this.relManutencaoTiposEquipamentos,
                limites_por_tipo: this.relManutencaoLimitesPorTipo,
            };
            const configPayload = {
                ...this.config,
                escopo_envio_qrcode: this.escopoQrcode,
            };
            const configPromise = apiController.request(apiController.endpoints.updateConfig, { data: configPayload, silent: true });
            const relManutencaoTiposPromise = apiController.request(apiController.endpoints.updateRelmanutencaotiposequipamentos, { data: relManutencaoTiposPayload, silent: true });

            const headersData = this.headers.map((h) => ({
                id_header: h.id_header,
                to_show: h.to_show,
                column_order: h.column_order,
                to_export: Number(h.to_export) ? 1 : 0,
                label: (h.label || h.text || '').trim() || h.originalText || '',
            }));

            const headersPromise = apiController.request(apiController.endpoints.updateHeader, { data: headersData, silent: true });

            let tipos = [];
            let canais = [];
            for (let tipo of this.tiposNotificacoes) {
                tipos.push([
                    tipo.id_tipo_notificacao,
                    tipo.descricao_tipo_notificacao,
                    tipo.cod_notificacao,
                    tipo.show_alerta,
                    tipo.cor,
                    tipo.show_relatorio,
                    tipo.envia_mensagem_automatica,
                    tipo.hierarquia_notificacao
                ]);

                if (tipo.canais.length > 0) {
                    for (let canal of tipo.canais) {
                        canais.push([
                            tipo.id_tipo_notificacao,
                            canal
                        ]);
                    }
                }
            }

            const tiposPromise = apiController.request(apiController.endpoints.updateTiposnotificacoes, { data: { tipos: tipos, canais: canais }, silent: true });

            const ticketCamposPromise = apiController.request(apiController.endpoints.updateTicketCamposCriacao, { data: this.ticketCamposCriacao, silent: true });

            const ticketCamposDetalhePromise = apiController.request(apiController.endpoints.updateTicketCamposDetalhe, { data: this.ticketCamposDetalhe, silent: true });

            const emailsGruposPromise = apiController.request(apiController.endpoints.updateEmailsequipes, {
                data: {
                    // Só os alterados: quem tem escopo limitado de equipes não trava o salvamento geral.
                    itens: this.gruposSolucionadores
                        .filter((g) => (g.email_encaminhamento || '') !== g.email_gravado)
                        .map(({ id_equipe, email_encaminhamento }) => ({ id_equipe, email_encaminhamento }))
                },
                silent: true
            });

            const savePromises = [configPromise, relManutencaoTiposPromise, headersPromise, tiposPromise, ticketCamposPromise, ticketCamposDetalhePromise, emailsGruposPromise];

            if (this.canManageLimitesApiExternas) {
                const limitesPayload = this.limitesApiExternas.map(({ id_servico_externo, limite_chamadas, dia_refresh }) => ({
                    id_servico_externo,
                    limite_chamadas: Math.max(0, parseInt(limite_chamadas, 10) || 0),
                    dia_refresh: Math.min(31, Math.max(1, parseInt(dia_refresh, 10) || 1))
                }));
                savePromises.push(
                    apiController.request(apiController.endpoints.updateLimitesapiexternas, { data: limitesPayload, silent: true })
                );
            }

            const statusVeiculosOperacaoPromise = apiController.request(apiController.endpoints.updateStatusveiculosoperacao, { data: this.statusVeiculosOperacao, silent: true });
            savePromises.push(statusVeiculosOperacaoPromise);

            try {
                const responses = await Promise.all(savePromises);
                const errorResp = responses.find(r => r.data && r.data.erro);
                this.showResult(errorResp ? errorResp.data : responses[0].data);
                if (!errorResp) {
                    this.setConfig(this.config);
                }
                this.clearHeadersCache();
                EventBus.$emit('config-updated');
                this.initialize();
            } catch (e) {
                EventBus.$emit('show-error', { error: e });
            }
        },
        clearHeadersCache() {
            const keys = [
                'headersPassageiros',
                'headersGrid',
                'headersPrevReal',
                'headersConciliacaoViagens',
                'headersConciliacaoViagensOperadora'
            ];
            keys.forEach(k => sessionStorage.removeItem(k));
        },
        showResult(resp) {
            window.scrollTo(0, 0);
            const tipo = resp.erro ? "error" : "success";

            EventBus.$emit('show-alert', {
                mensagem: resp.mensagem,
                tipo: tipo
            });
        },
        horarioRules(hora) {
            if (hora === null) return true;
            if (!/(([01][0-9])|(2[0-3])):([0-5][0-9])$/.test(hora)) {
                return this.$t('datetime.invalidTime');
            }

            return true;
        },
        getColor(value, lower, upper, type) {
            if (value >= lower && value <= upper) {
                return "orange";
            }

            if (type === "min") {
                return value >= upper ? "red" : "green";
            }

            if (type === "max") {
                return value <= lower ? "red" : "green";
            }

            return "primary";
        },
        getHeadersByTable(idTabela) {
            return this.headers
                .filter((header) => header.id_tabela === idTabela)
                .slice()
                .sort((a, b) => a.column_order - b.column_order);
        },
        ordenar(item, direction) {
            if (!item || !item.id_tabela) {
                return;
            }

            const tableHeaders = this.getHeadersByTable(item.id_tabela);
            const currentIndex = tableHeaders.findIndex((header) => header.id_header === item.id_header);

            if (currentIndex === -1) {
                return;
            }

            const targetIndex = direction === "up" ? currentIndex - 1 : currentIndex + 1;
            if (targetIndex < 0 || targetIndex >= tableHeaders.length) {
                return;
            }

            const currentItem = tableHeaders[currentIndex];
            const targetItem = tableHeaders[targetIndex];

            if (!currentItem || !targetItem) {
                return;
            }

            [tableHeaders[currentIndex], tableHeaders[targetIndex]] = [targetItem, currentItem];

            tableHeaders.forEach((header, index) => {
                header.column_order = index + 1;
            });
        },
        toggleHeader(obj) {
            let { item, value } = obj;
            item.to_show = value ? 1 : 0;
        },
        toggleAll(obj) {
            let { items, value } = obj;
            items.forEach((item) => {
                let headerItem = this.headers.find((h) => h.id_header === item.id_header);
                headerItem.to_show = value ? 1 : 0;
            });

        }
    },
    watch: {
        // Sincroniza periodoHoras quando periodo_busca_alertas_minutos mudar diretamente
        'config.periodo_busca_alertas_minutos'(newVal) {
            if (newVal !== null && newVal !== undefined) {
                this.periodoHoras = Math.round((newVal / 60) * 100) / 100;
            }
        },
        '$route.query.section'() {
            this.applySectionFromRoute();
        },
        '$i18n.locale'() {
            this.initialize();
        }
    }
}
</script>

<style scoped>
:deep(.v-list-item__title),
:deep(.v-list-item__subtitle),
:deep(.v-list-item-title),
:deep(.v-list-item-subtitle),
:deep(.v-list-item__subtitle .text-body-2),
:deep(.v-list-item__subtitle .v-list-item__subtitle) {
    white-space: normal !important;
    word-break: break-word !important;
    overflow: visible !important;
    text-overflow: unset !important;
    display: block !important;
}

:deep(.v-text-field--dense .v-input__slot),
:deep(.v-input--dense .v-input__slot) {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
}

:deep(.v-list-item) {
    margin-bottom: 8px !important;
}

/* Reduz espaçamento horizontal entre colunas */
:deep(.v-col) {
    padding-left: 8px !important;
    padding-right: 8px !important;
}

.d-flex.align-center {
    align-items: center !important;
    gap: 4px;
}

.config-relatorios-group :deep(.v-list-item__content),
.config-relatorios-limites-card,
.config-relatorios-limite-row {
    min-width: 0;
    width: 100%;
}

.config-relatorios-limite-nome {
    overflow-wrap: anywhere;
}

.config-relatorios-aba-item {
    min-width: 0;
    height: 100%;
    padding: 4px 0 8px;
}

.config-relatorios-aba-titulo,
.config-relatorios-aba-subtitulo {
    overflow-wrap: anywhere;
    white-space: normal;
}

.config-relatorios-aba-titulo {
    margin-bottom: 4px;
    font-size: 16px;
    line-height: 1.25;
    font-weight: 500;
}

.config-relatorios-aba-subtitulo {
    min-height: 40px;
    margin-bottom: 8px;
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
    line-height: 1.25;
}

.config-hikvision-limit {
    min-width: 0;
}

.config-hikvision-limit-title {
    margin-bottom: 4px;
    overflow-wrap: anywhere;
    white-space: normal;
    font-size: 16px;
    line-height: 1.25;
    font-weight: 500;
}

@media (max-width: 600px) {
    .config-relatorios-limites-card {
        padding: 12px !important;
    }

    .config-relatorios-limites-card .v-chip {
        height: auto !important;
        min-height: 32px;
        max-width: 100%;
        white-space: normal;
    }

    .config-relatorios-aba-subtitulo {
        min-height: 0;
    }
}
</style>
